/* SkyStruct website — generated bundle. Edit src/scripts/*.js */
/* ==== ss-website-vendor-lenis.js ==== */
/*! Lenis v1.3.26 — MIT License — https://github.com/darkroomengineering/lenis (vendored, unmodified) */
(function(){var e=`1.3.26`;function t(e,t,n){return Math.max(e,Math.min(t,n))}function n(e,t,n){return(1-n)*e+n*t}function r(e,t,r,i){return n(e,t,1-Math.exp(-r*i))}function i(e,t){return(e%t+t)%t}var a=class{isRunning=!1;value=0;from=0;to=0;currentTime=0;lerp;duration;easing;onUpdate;advance(e){if(!this.isRunning)return;let n=!1;if(this.duration&&this.easing){this.currentTime+=e;let r=t(0,this.currentTime/this.duration,1);n=r>=1;let i=n?1:this.easing(r);this.value=this.from+(this.to-this.from)*i}else this.lerp?(this.value=r(this.value,this.to,this.lerp*60,e),Math.round(this.value)===Math.round(this.to)&&(this.value=this.to,n=!0)):(this.value=this.to,n=!0);n&&this.stop(),this.onUpdate?.(this.value,n)}stop(){this.isRunning=!1}fromTo(e,t,{lerp:n,duration:r,easing:i,onStart:a,onUpdate:o}){this.from=this.value=e,this.to=t,this.lerp=n,this.duration=r,this.easing=i,this.currentTime=0,this.isRunning=!0,a?.(),this.onUpdate=o}};function o(e,t){let n;return function(...r){clearTimeout(n),n=setTimeout(()=>{n=void 0,e.apply(this,r)},t)}}var s=class{width=0;height=0;scrollHeight=0;scrollWidth=0;debouncedResize;wrapperResizeObserver;contentResizeObserver;constructor(e,t,{autoResize:n=!0,debounce:r=250}={}){this.wrapper=e,this.content=t,n&&(this.debouncedResize=o(this.resize,r),this.wrapper instanceof Window?window.addEventListener(`resize`,this.debouncedResize):(this.wrapperResizeObserver=new ResizeObserver(this.debouncedResize),this.wrapperResizeObserver.observe(this.wrapper)),this.contentResizeObserver=new ResizeObserver(this.debouncedResize),this.contentResizeObserver.observe(this.content)),this.resize()}destroy(){this.wrapperResizeObserver?.disconnect(),this.contentResizeObserver?.disconnect(),this.wrapper===window&&this.debouncedResize&&window.removeEventListener(`resize`,this.debouncedResize)}resize=()=>{this.onWrapperResize(),this.onContentResize()};onWrapperResize=()=>{this.wrapper instanceof Window?(this.width=window.innerWidth,this.height=window.innerHeight):(this.width=this.wrapper.clientWidth,this.height=this.wrapper.clientHeight)};onContentResize=()=>{this.wrapper instanceof Window?(this.scrollHeight=this.content.scrollHeight,this.scrollWidth=this.content.scrollWidth):(this.scrollHeight=this.wrapper.scrollHeight,this.scrollWidth=this.wrapper.scrollWidth)};get limit(){return{x:this.scrollWidth-this.width,y:this.scrollHeight-this.height}}},c=class{events={};emit(e,...t){let n=this.events[e]||[];for(let e=0,r=n.length;e<r;e++)n[e]?.(...t)}on(e,t){return this.events[e]?this.events[e].push(t):this.events[e]=[t],()=>{this.events[e]=this.events[e]?.filter(e=>t!==e)}}off(e,t){this.events[e]=this.events[e]?.filter(e=>t!==e)}destroy(){this.events={}}};let l={passive:!1};function u(e,t){return e===1?16.666666666666668:e===2?t:1}var d=class{touchStart={x:0,y:0};lastDelta={x:0,y:0};window={width:0,height:0};emitter=new c;constructor(e,t={wheelMultiplier:1,touchMultiplier:1}){this.element=e,this.options=t,window.addEventListener(`resize`,this.onWindowResize),this.onWindowResize(),this.element.addEventListener(`wheel`,this.onWheel,l),this.element.addEventListener(`touchstart`,this.onTouchStart,l),this.element.addEventListener(`touchmove`,this.onTouchMove,l),this.element.addEventListener(`touchend`,this.onTouchEnd,l)}on(e,t){return this.emitter.on(e,t)}destroy(){this.emitter.destroy(),window.removeEventListener(`resize`,this.onWindowResize),this.element.removeEventListener(`wheel`,this.onWheel,l),this.element.removeEventListener(`touchstart`,this.onTouchStart,l),this.element.removeEventListener(`touchmove`,this.onTouchMove,l),this.element.removeEventListener(`touchend`,this.onTouchEnd,l)}onTouchStart=e=>{let{clientX:t,clientY:n}=e.targetTouches?e.targetTouches[0]:e;this.touchStart.x=t,this.touchStart.y=n,this.lastDelta={x:0,y:0},this.emitter.emit(`scroll`,{deltaX:0,deltaY:0,event:e})};onTouchMove=e=>{let{clientX:t,clientY:n}=e.targetTouches?e.targetTouches[0]:e,r=-(t-this.touchStart.x)*this.options.touchMultiplier,i=-(n-this.touchStart.y)*this.options.touchMultiplier;this.touchStart.x=t,this.touchStart.y=n,this.lastDelta={x:r,y:i},this.emitter.emit(`scroll`,{deltaX:r,deltaY:i,event:e})};onTouchEnd=e=>{this.emitter.emit(`scroll`,{deltaX:this.lastDelta.x,deltaY:this.lastDelta.y,event:e})};onWheel=e=>{let{deltaX:t,deltaY:n,deltaMode:r}=e,i=u(r,this.window.width),a=u(r,this.window.height);t*=i,n*=a,t*=this.options.wheelMultiplier,n*=this.options.wheelMultiplier,this.emitter.emit(`scroll`,{deltaX:t,deltaY:n,event:e})};onWindowResize=()=>{this.window={width:window.innerWidth,height:window.innerHeight}}};let f=e=>Math.min(1,1.001-2**(-10*e));var p=class{_isScrolling=!1;_isStopped=!1;_isLocked=!1;_preventNextNativeScrollEvent=!1;_resetVelocityTimeout=null;_rafId=null;_isDraggingSelection=!1;reducedMotionMediaQuery=window.matchMedia(`(prefers-reduced-motion: reduce)`);isTouching;isIos;time=0;userData={};lastVelocity=0;velocity=0;direction=0;options;targetScroll;animatedScroll;animate=new a;emitter=new c;dimensions;virtualScroll;constructor({wrapper:t=window,content:n=document.documentElement,eventsTarget:r=t,smoothWheel:i=!0,syncTouch:a=!1,syncTouchLerp:o=.075,touchInertiaExponent:c=1.7,duration:l,easing:u,lerp:p=.1,infinite:m=!1,orientation:h=`vertical`,gestureOrientation:g=h===`horizontal`?`both`:`vertical`,touchMultiplier:_=1,wheelMultiplier:v=1,autoResize:y=!0,prevent:b,virtualScroll:x,overscroll:S=!0,autoRaf:C=!1,anchors:w=!1,autoToggle:T=!1,allowNestedScroll:E=!1,__experimental__naiveDimensions:D=!1,naiveDimensions:O=D,stopInertiaOnNavigate:k=!1,respectReducedMotion:A=!0}={}){window.lenisVersion=e,window.lenis||(window.lenis={}),window.lenis.version=e,h===`horizontal`&&(window.lenis.horizontal=!0),a===!0&&(window.lenis.touch=!0),this.isIos=/(iPad|iPhone|iPod)/g.test(navigator.userAgent),(!t||t===document.documentElement)&&(t=window),typeof l==`number`&&typeof u!=`function`?u=f:typeof u==`function`&&typeof l!=`number`&&(l=1),this.options={wrapper:t,content:n,eventsTarget:r,smoothWheel:i,syncTouch:a,syncTouchLerp:o,touchInertiaExponent:c,duration:l,easing:u,lerp:p,infinite:m,gestureOrientation:g,orientation:h,touchMultiplier:_,wheelMultiplier:v,autoResize:y,prevent:b,virtualScroll:x,overscroll:S,autoRaf:C,anchors:w,autoToggle:T,allowNestedScroll:E,naiveDimensions:O,stopInertiaOnNavigate:k,respectReducedMotion:A},this.dimensions=new s(t,n,{autoResize:y}),this.updateClassName(),this.targetScroll=this.animatedScroll=this.actualScroll,this.options.wrapper.addEventListener(`scroll`,this.onNativeScroll),this.options.wrapper.addEventListener(`scrollend`,this.onScrollEnd,{capture:!0}),(this.options.anchors||this.options.stopInertiaOnNavigate)&&this.options.wrapper.addEventListener(`click`,this.onClick),this.options.wrapper.addEventListener(`pointerdown`,this.onPointerDown),this.virtualScroll=new d(r,{touchMultiplier:_,wheelMultiplier:v}),this.virtualScroll.on(`scroll`,this.onVirtualScroll),this.options.autoToggle&&(this.checkOverflow(),this.rootElement.addEventListener(`transitionend`,this.onTransitionEnd)),this.options.autoRaf&&(this._rafId=requestAnimationFrame(this.raf))}destroy(){this.emitter.destroy(),this.options.wrapper.removeEventListener(`scroll`,this.onNativeScroll),this.options.wrapper.removeEventListener(`scrollend`,this.onScrollEnd,{capture:!0}),this.options.wrapper.removeEventListener(`pointerdown`,this.onPointerDown),(this.options.anchors||this.options.stopInertiaOnNavigate)&&this.options.wrapper.removeEventListener(`click`,this.onClick),this.virtualScroll.destroy(),this.dimensions.destroy(),this.cleanUpClassName(),this._rafId&&cancelAnimationFrame(this._rafId)}on(e,t){return this.emitter.on(e,t)}off(e,t){return this.emitter.off(e,t)}onScrollEnd=e=>{e instanceof CustomEvent||(this.isScrolling===`smooth`||this.isScrolling===!1)&&e.stopPropagation()};dispatchScrollendEvent=()=>{this.options.wrapper.dispatchEvent(new CustomEvent(`scrollend`,{bubbles:this.options.wrapper===window,detail:{lenisScrollEnd:!0}}))};get overflow(){let e=this.isHorizontal?`overflow-x`:`overflow-y`;return getComputedStyle(this.rootElement)[e]}checkOverflow(){[`hidden`,`clip`].includes(this.overflow)?this.internalStop():this.internalStart()}onTransitionEnd=e=>{e.propertyName?.includes(`overflow`)&&e.target===this.rootElement&&this.checkOverflow()};setScroll(e){this.isHorizontal?this.options.wrapper.scrollTo({left:e,behavior:`instant`}):this.options.wrapper.scrollTo({top:e,behavior:`instant`})}onClick=e=>{let t=e.composedPath().filter(e=>e instanceof HTMLAnchorElement&&e.href).map(e=>new URL(e.href)),n=new URL(window.location.href);if(this.options.anchors){let e=t.find(e=>n.host===e.host&&n.pathname===e.pathname&&e.hash);if(e){let t=typeof this.options.anchors==`object`&&this.options.anchors?this.options.anchors:void 0,n=decodeURIComponent(e.hash);this.scrollTo(n,t);return}}if(this.options.stopInertiaOnNavigate&&t.some(e=>n.host===e.host&&n.pathname!==e.pathname)){this.reset();return}};onPointerDown=e=>{e.button===1&&this.reset()};isTouchOnSelectionHandle(e){let t=window.getSelection();if(!t||t.isCollapsed||t.rangeCount===0)return!1;let n=e.targetTouches[0]??e.changedTouches[0];if(!n)return!1;let r=t.getRangeAt(0).getClientRects();if(r.length===0)return!1;let i=r[0],a=r[r.length-1],o=Math.hypot(n.clientX-i.left,n.clientY-i.top)<=40,s=Math.hypot(n.clientX-a.right,n.clientY-a.bottom)<=40;return o||s}onVirtualScroll=e=>{if(typeof this.options.virtualScroll==`function`&&this.options.virtualScroll(e)===!1)return;let{deltaX:t,deltaY:n,event:r}=e;if(this.emitter.emit(`virtual-scroll`,{deltaX:t,deltaY:n,event:r}),r.ctrlKey||r.lenisStopPropagation)return;let i=r.type.includes(`touch`),a=r.type.includes(`wheel`);if(i&&this.isIos&&(r.type===`touchstart`&&(this._isDraggingSelection=this.isTouchOnSelectionHandle(r)),this._isDraggingSelection)){r.type===`touchend`&&(this._isDraggingSelection=!1);return}this.isTouching=r.type===`touchstart`||r.type===`touchmove`;let o=t===0&&n===0;if(this.options.syncTouch&&i&&r.type===`touchstart`&&o&&!this.isStopped&&!this.isLocked){this.reset();return}let s=this.options.gestureOrientation===`vertical`&&n===0||this.options.gestureOrientation===`horizontal`&&t===0;if(o||s)return;let c=r.composedPath();c=c.slice(0,c.indexOf(this.rootElement));let l=this.options.prevent,u=Math.abs(t)>=Math.abs(n)?`horizontal`:`vertical`;if(c.find(e=>e instanceof HTMLElement&&(typeof l==`function`&&l?.(e)||e.hasAttribute?.(`data-lenis-prevent`)||u===`vertical`&&e.hasAttribute?.(`data-lenis-prevent-vertical`)||u===`horizontal`&&e.hasAttribute?.(`data-lenis-prevent-horizontal`)||i&&e.hasAttribute?.(`data-lenis-prevent-touch`)||a&&e.hasAttribute?.(`data-lenis-prevent-wheel`)||this.options.allowNestedScroll&&this.hasNestedScroll(e,{deltaX:t,deltaY:n}))))return;if(this.isStopped||this.isLocked){r.cancelable&&r.preventDefault();return}if(!(this.options.syncTouch&&i||this.options.smoothWheel&&a)){this.isScrolling=`native`,this.animate.stop(),r.lenisStopPropagation=!0;return}let d=n;this.options.gestureOrientation===`both`?d=Math.abs(n)>Math.abs(t)?n:t:this.options.gestureOrientation===`horizontal`&&(d=t),(!this.options.overscroll||this.options.infinite||this.options.wrapper!==window&&this.limit>0&&(this.animatedScroll>0&&this.animatedScroll<this.limit||this.animatedScroll===0&&n>0||this.animatedScroll===this.limit&&n<0))&&(r.lenisStopPropagation=!0),r.cancelable&&r.preventDefault();let f=i&&this.options.syncTouch,p=i&&r.type===`touchend`;p&&(d=Math.sign(d)*Math.abs(this.velocity)**this.options.touchInertiaExponent),this.scrollTo(this.targetScroll+d,{programmatic:!1,...f?{lerp:p?this.options.syncTouchLerp:1}:{lerp:this.options.lerp,duration:this.options.duration,easing:this.options.easing}})};resize(){this.dimensions.resize(),this.animatedScroll=this.targetScroll=this.actualScroll,this.emit()}emit(){this.emitter.emit(`scroll`,this)}onNativeScroll=()=>{if(this._resetVelocityTimeout!==null&&(clearTimeout(this._resetVelocityTimeout),this._resetVelocityTimeout=null),this._preventNextNativeScrollEvent){this._preventNextNativeScrollEvent=!1;return}if(this.isScrolling===!1||this.isScrolling===`native`){let e=this.animatedScroll;this.animatedScroll=this.targetScroll=this.actualScroll,this.lastVelocity=this.velocity,this.velocity=this.animatedScroll-e,this.direction=Math.sign(this.animatedScroll-e),this.isStopped||(this.isScrolling=`native`),this.emit(),this.velocity!==0&&(this._resetVelocityTimeout=setTimeout(()=>{this.lastVelocity=this.velocity,this.velocity=0,this.isScrolling=!1,this.emit()},400))}};reset(){this.isLocked=!1,this.isScrolling=!1,this.animatedScroll=this.targetScroll=this.actualScroll,this.lastVelocity=this.velocity=0,this.animate.stop()}start(){if(this.isStopped){if(this.options.autoToggle){this.rootElement.style.removeProperty(`overflow`);return}this.internalStart()}}internalStart(){this.isStopped&&(this.reset(),this.isStopped=!1,this.emit())}stop(){if(!this.isStopped){if(this.options.autoToggle){this.rootElement.style.setProperty(`overflow`,`clip`);return}this.internalStop()}}internalStop(){this.isStopped||(this.reset(),this.isStopped=!0,this.emit())}raf=e=>{let t=e-(this.time||e);this.time=e,this.animate.advance(t*.001),this.options.autoRaf&&(this._rafId=requestAnimationFrame(this.raf))};scrollTo(e,{offset:n=0,immediate:r=!1,lock:i=!1,programmatic:a=!0,lerp:o=a?this.options.lerp:void 0,duration:s=a?this.options.duration:void 0,easing:c=a?this.options.easing:void 0,onStart:l,onComplete:u,force:d=!1,userData:p}={}){if(this.prefersReducedMotion&&(a?r=!0:(o=1,s=void 0,c=void 0)),(this.isStopped||this.isLocked)&&!d)return;let m=e,h=n;if(typeof m==`string`&&[`top`,`left`,`start`,`#`].includes(m))m=0;else if(typeof m==`string`&&[`bottom`,`right`,`end`].includes(m))m=this.limit;else{let e=null;if(typeof m==`string`?(e=m.startsWith(`#`)?document.getElementById(m.slice(1)):document.querySelector(m),e||(m===`#top`?m=0:console.warn(`Lenis: Target not found`,m))):m instanceof HTMLElement&&m?.nodeType&&(e=m),e){if(this.options.wrapper!==window){let e=this.rootElement.getBoundingClientRect();h-=this.isHorizontal?e.left:e.top}let t=e.getBoundingClientRect(),n=getComputedStyle(e),r=this.isHorizontal?Number.parseFloat(n.scrollMarginLeft):Number.parseFloat(n.scrollMarginTop),i=getComputedStyle(this.rootElement),a=this.isHorizontal?Number.parseFloat(i.scrollPaddingLeft):Number.parseFloat(i.scrollPaddingTop);m=(this.isHorizontal?t.left:t.top)+this.animatedScroll-(Number.isNaN(r)?0:r)-(Number.isNaN(a)?0:a)}}if(typeof m==`number`){if(m+=h,this.options.infinite){if(a){this.targetScroll=this.animatedScroll=this.scroll;let e=m-this.animatedScroll;e>this.limit/2?m-=this.limit:e<-this.limit/2&&(m+=this.limit)}}else m=t(0,m,this.limit);if(m===this.targetScroll){l?.(this),u?.(this);return}if(this.userData=p??{},r){this.animatedScroll=this.targetScroll=m,this.setScroll(this.scroll),this.reset(),this.preventNextNativeScrollEvent(),this.emit(),u?.(this),this.userData={},requestAnimationFrame(()=>{this.dispatchScrollendEvent()});return}a||(this.targetScroll=m),typeof s==`number`&&typeof c!=`function`?c=f:typeof c==`function`&&typeof s!=`number`&&(s=1),this.animate.fromTo(this.animatedScroll,m,{duration:s,easing:c,lerp:o,onStart:()=>{i&&(this.isLocked=!0),this.isScrolling=`smooth`,l?.(this)},onUpdate:(e,t)=>{this.isScrolling=`smooth`,this.lastVelocity=this.velocity,this.velocity=e-this.animatedScroll,this.direction=Math.sign(this.velocity),this.animatedScroll=e,this.setScroll(this.scroll),a&&(this.targetScroll=e),t||this.emit(),t&&(this.reset(),this.emit(),u?.(this),this.userData={},requestAnimationFrame(()=>{this.dispatchScrollendEvent()}),this.preventNextNativeScrollEvent())}})}}preventNextNativeScrollEvent(){this._preventNextNativeScrollEvent=!0,requestAnimationFrame(()=>{this._preventNextNativeScrollEvent=!1})}hasNestedScroll(e,{deltaX:t,deltaY:n}){let r=Date.now();e._lenis||={};let i=e._lenis,a,o,s,c,l,u,d,f,p,m;if(r-(i.time??0)>2e3){i.time=Date.now();let t=window.getComputedStyle(e);if(i.computedStyle=t,a=[`auto`,`overlay`,`scroll`].includes(t.overflowX),o=[`auto`,`overlay`,`scroll`].includes(t.overflowY),l=[`auto`].includes(t.overscrollBehaviorX),u=[`auto`].includes(t.overscrollBehaviorY),i.hasOverflowX=a,i.hasOverflowY=o,!(a||o))return!1;d=e.scrollWidth,f=e.scrollHeight,p=e.clientWidth,m=e.clientHeight,s=d>p,c=f>m,i.isScrollableX=s,i.isScrollableY=c,i.scrollWidth=d,i.scrollHeight=f,i.clientWidth=p,i.clientHeight=m,i.hasOverscrollBehaviorX=l,i.hasOverscrollBehaviorY=u}else s=i.isScrollableX,c=i.isScrollableY,a=i.hasOverflowX,o=i.hasOverflowY,d=i.scrollWidth,f=i.scrollHeight,p=i.clientWidth,m=i.clientHeight,l=i.hasOverscrollBehaviorX,u=i.hasOverscrollBehaviorY;if(!(a&&s||o&&c))return!1;let h=Math.abs(t)>=Math.abs(n)?`horizontal`:`vertical`,g,_,v,y,b,x;if(h===`horizontal`)g=Math.round(e.scrollLeft),_=d-p,v=t,y=a,b=s,x=l;else if(h===`vertical`)g=Math.round(e.scrollTop),_=f-m,v=n,y=o,b=c,x=u;else return!1;return!x&&(g>=_||g<=0)?!0:(v>0?g<_:g>0)&&y&&b}get rootElement(){return this.options.wrapper===window?document.documentElement:this.options.wrapper}get limit(){return this.options.naiveDimensions?this.isHorizontal?this.rootElement.scrollWidth-this.rootElement.clientWidth:this.rootElement.scrollHeight-this.rootElement.clientHeight:this.dimensions.limit[this.isHorizontal?`x`:`y`]}get isHorizontal(){return this.options.orientation===`horizontal`}get actualScroll(){let e=this.options.wrapper;return this.isHorizontal?e.scrollX??e.scrollLeft:e.scrollY??e.scrollTop}get scroll(){return this.options.infinite?i(this.animatedScroll,this.limit):this.animatedScroll}get progress(){return this.limit===0?1:this.scroll/this.limit}get isScrolling(){return this._isScrolling}set isScrolling(e){this._isScrolling!==e&&(this._isScrolling=e,this.updateClassName())}get isStopped(){return this._isStopped}set isStopped(e){this._isStopped!==e&&(this._isStopped=e,this.updateClassName())}get isLocked(){return this._isLocked}set isLocked(e){this._isLocked!==e&&(this._isLocked=e,this.updateClassName())}get isSmooth(){return this.isScrolling===`smooth`}get prefersReducedMotion(){return this.options.respectReducedMotion&&this.reducedMotionMediaQuery.matches}get className(){let e=`lenis`;return this.options.autoToggle&&(e+=` lenis-autoToggle`),this.isStopped&&(e+=` lenis-stopped`),this.isLocked&&(e+=` lenis-locked`),this.isScrolling&&(e+=` lenis-scrolling`),this.isScrolling===`smooth`&&(e+=` lenis-smooth`),e}updateClassName(){this.cleanUpClassName(),this.className.split(` `).forEach(e=>{this.rootElement.classList.add(e)})}cleanUpClassName(){for(let e of Array.from(this.rootElement.classList))(e===`lenis`||e.startsWith(`lenis-`))&&this.rootElement.classList.remove(e)}};globalThis.Lenis=p,globalThis.Lenis.prototype=p.prototype})();

/* ==== ss-website-core.js ==== */
/* SkyStruct website core: namespace, safe storage, scroll reveals, SFX hook. */
(function () {
  'use strict';
  var ss = (window.SkyStruct = window.SkyStruct || {});
  var html = document.documentElement;

  ss.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  ss.prefersReducedMotion = function () { return ss.reducedMotion.matches; };
  ss.isRtl = function () { return html.dir === 'rtl'; };
  ss.ready = function (fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  // Storage is a per-visitor convenience only; every access is guarded.
  ss.store = {
    get: function (key, fallback) {
      try {
        var v = window.localStorage.getItem('ss-website-' + key);
        return v === null ? fallback : JSON.parse(v);
      } catch (e) { return fallback; }
    },
    set: function (key, value) {
      try { window.localStorage.setItem('ss-website-' + key, JSON.stringify(value)); } catch (e) { /* storage unavailable */ }
    },
  };

  // Play a one-shot CSS entrance animation and clean up afterwards.
  ss.animateIn = function (el) {
    if (ss.prefersReducedMotion()) return;
    el.classList.remove('is-entering');
    void el.offsetWidth;
    el.classList.add('is-entering');
    // Children animate too (and their animationend events bubble), so clean up on a timer.
    clearTimeout(el.ssEnterTimer);
    el.ssEnterTimer = setTimeout(function () { el.classList.remove('is-entering'); }, 1200);
  };

  // Replaced by the audio module; safe no-op until then.
  ss.sfx = function () {};

  // One-shot visibility observer shared by reveals and diagrams.
  ss.onVisible = function (elements, callback, options) {
    var list = Array.prototype.slice.call(elements);
    if (!list.length) return;
    if (!('IntersectionObserver' in window)) { list.forEach(callback); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { io.unobserve(entry.target); callback(entry.target); }
      });
    }, options || { rootMargin: '0px 0px -4% 0px', threshold: 0.04 });
    list.forEach(function (el) { io.observe(el); });
  };

  ss.ready(function () {
    ss.onVisible(document.querySelectorAll('[data-ss-reveal]'), function (el) { el.classList.add('is-revealed'); });
  });

  /* Peer rows: components presented as peers keep equivalent content on the same rows.
     Inside each [data-ss-peers] group, every [data-ss-peer-row="name"] gets the natural height
     of the tallest visible element with the same name (layout height, unaffected by transforms).
     Re-measured on resize, font load and tab/panel changes. CSS owns the structure; this only
     equalises the variable rows (titles that wrap, optional badges, copy of different length). */
  function equalise(group) {
    var rows = {};
    group.querySelectorAll('[data-ss-peer-row]').forEach(function (el) {
      if (el.closest('[data-ss-peers]') !== group) return;
      el.style.minHeight = '';
      var k = el.getAttribute('data-ss-peer-row');
      (rows[k] = rows[k] || []).push(el);
    });
    Object.keys(rows).forEach(function (k) {
      var els = rows[k].filter(function (el) { return el.offsetParent !== null || getComputedStyle(el).position === 'fixed'; });
      if (els.length < 2) return;
      // Only peers that sit side by side share a row height; stacked peers (phones) keep their own.
      var spans = els.map(function (el) { var r = el.getBoundingClientRect(); return [r.left, r.right]; });
      for (var i = 0; i < spans.length; i++) for (var j = i + 1; j < spans.length; j++) {
        if (Math.min(spans[i][1], spans[j][1]) - Math.max(spans[i][0], spans[j][0]) > 8) return;
      }
      var max = 0;
      els.forEach(function (el) { max = Math.max(max, el.offsetHeight); });
      els.forEach(function (el) { el.style.minHeight = max + 'px'; });
    });
  }
  ss.equalisePeers = function () { document.querySelectorAll('[data-ss-peers]').forEach(equalise); };
  ss.ready(function () {
    if (!document.querySelector('[data-ss-peers]')) return;
    var raf = 0, lastW = window.innerWidth;
    var run = function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(ss.equalisePeers); };
    run();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
    window.addEventListener('load', run);
    window.addEventListener('resize', function () { if (window.innerWidth !== lastW) { lastW = window.innerWidth; run(); } });
    document.addEventListener('ss:panel', run);
    var onTab = function (e) { if (e.target.closest && e.target.closest('[data-ss-tab]')) run(); };
    document.addEventListener('click', onTab);
    document.addEventListener('keyup', onTab);
  });

  // Sound feedback on the committing interaction (click), never on hover.
  document.addEventListener('click', function (event) {
    var el = event.target.closest && event.target.closest('[data-ss-sfx]');
    if (el) ss.sfx(el.getAttribute('data-ss-sfx'));
  }, true);
})();

/* ==== ss-website-scroll.js ==== */
/* SkyStruct scroll: gentle wheel smoothing (Lenis) + one shared engine for
   scroll-driven scenes. Native scrolling is never replaced: touch, keyboard,
   scrollbars and anchors keep browser behaviour; reduced motion disables smoothing.

   Scenes: any element with [data-ss-scene] receives --ss-progress (0 → 1), and
   registered handlers get the same value.
   - default ("pin"): progress across a tall sticky section (top reaches viewport top → bottom reaches viewport bottom).
   - "view": progress from the element entering at the bottom of the viewport to leaving at the top. */
(function () {
  'use strict';
  var ss = window.SkyStruct;
  var html = document.documentElement;
  var scenes = [];
  var ticking = false;

  function measure(scene) {
    var r = scene.el.getBoundingClientRect();
    var vh = window.innerHeight;
    var p = scene.mode === 'view' ? (vh - r.top) / (vh + r.height) : -r.top / Math.max(r.height - vh, 1);
    p = Math.round(Math.min(Math.max(p, 0), 1) * 1000) / 1000;
    if (p !== scene.progress) {
      scene.progress = p;
      scene.el.style.setProperty('--ss-progress', p);
      scene.handlers.forEach(function (fn) { fn(p, scene.el); });
    }
  }
  var scrollHandlers = [];
  function update() {
    ticking = false;
    scenes.forEach(function (s) { if (s.visible) measure(s); });
    for (var i = 0; i < scrollHandlers.length; i++) scrollHandlers[i]();
  }
  function request() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }

  /** Register a handler for a scene element; returns nothing. */
  ss.onScene = function (el, handler, mode) {
    var scene = scenes.filter(function (s) { return s.el === el; })[0];
    if (!scene) {
      scene = { el: el, progress: -1, visible: true, handlers: [], mode: mode || el.getAttribute('data-ss-scene') || 'pin' };
      scenes.push(scene);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { scene.visible = e.isIntersecting; if (e.isIntersecting) measure(scene); });
        }, { rootMargin: '20% 0px 20% 0px' }).observe(el);
      }
    }
    if (handler) scene.handlers.push(handler);
    measure(scene);
  };

  /** Run fn once per animation frame after scroll/resize — the site's single scroll listener. */
  ss.onScroll = function (fn) { scrollHandlers.push(fn); };

  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request);

  ss.ready(function () {
    document.querySelectorAll('[data-ss-scene]').forEach(function (el) { ss.onScene(el); });

    // Smooth wheel scrolling — fine pointers only, never with reduced motion.
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    // Standalone experiences (Company Profile) do not scroll the page: no smoothing there.
    if (!window.Lenis || !fine || ss.prefersReducedMotion() || document.body.classList.contains('ss-website-body--standalone')) return;
    var lenis = new window.Lenis({ lerp: 0.11, smoothWheel: true, syncTouch: false, anchors: { offset: -88 } });
    ss.lenis = lenis;
    html.classList.add('ss-website-smooth');
    // Run Lenis only while it has work: wake on input, sleep after ~20 idle frames (no idle 60fps loop).
    var running = false, idle = 0;
    function raf(time) {
      lenis.raf(time);
      idle = lenis.isScrolling ? 0 : idle + 1;
      if (idle < 20) window.requestAnimationFrame(raf); else running = false;
    }
    function wake() {
      idle = 0;
      if (running) return;
      running = true;
      lenis.time = performance.now(); // fresh clock: no catch-up jump on the first frame after sleeping
      window.requestAnimationFrame(raf);
    }
    ['wheel', 'keydown', 'pointerdown', 'touchstart'].forEach(function (ev) { window.addEventListener(ev, wake, { passive: true, capture: true }); });
    var scrollTo = lenis.scrollTo.bind(lenis);
    lenis.scrollTo = function () { wake(); return scrollTo.apply(null, arguments); };
    wake();
    ss.reducedMotion.addEventListener && ss.reducedMotion.addEventListener('change', function (e) { if (e.matches) { lenis.destroy(); ss.lenis = null; } });
  });
})();

/* ==== ss-website-navigation.js ==== */
/* SkyStruct navigation: adaptive header, mega menus, mobile sheet, current-page state. */
(function () {
  'use strict';
  var ss = window.SkyStruct;
  var html = document.documentElement;

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function normalisePath(p) { return p.replace(/index\.html$/, '').replace(/\/+$/, '') || '/'; }

  ss.ready(function () {
    var header = document.querySelector('[data-ss-header]');
    if (!header) return;

    /* ---------- Current page: mark matching menu links (mega menus + mobile) ---------- */
    var here = location.pathname.replace(/index\.html$/, '').replace(/\/+$/, '/');
    header.querySelectorAll('.ss-website-mega a[href], .ss-website-mobile-nav a[href]').forEach(function (a) {
      var path = new URL(a.getAttribute('href'), location.href).pathname.replace(/index\.html$/, '').replace(/\/+$/, '/');
      if (path === here) a.setAttribute('aria-current', 'page');
    });

    /* ---------- Header: scrolled state + tone of the surface underneath ---------- */
    /* Hide / reveal: explicit states, decided from accumulated scroll distance in one direction
       (scroll position only — wheel, trackpad, touch, keyboard and momentum all report through it).
       Down ≥ 14 px past 480 px → hidden; up ≥ 6 px → visible; near the top, with a menu open, with
       focus inside, or right after an in-page jump → always visible. */
    var lastY = Math.max(0, window.scrollY), run = 0, holdUntil = 0;
    var mobileSheet = header.querySelector('[data-ss-mobile-nav]');
    function setHidden(h) {
      if (header.classList.contains('is-hidden') === h) return;
      header.classList.toggle('is-hidden', h);
      header.classList.toggle('ss-website-header--visible', !h);
    }
    header.classList.add('ss-website-header--visible');
    window.addEventListener('hashchange', function () { holdUntil = Date.now() + 700; setHidden(false); });
    function updateHeader() {
      var sy = Math.max(0, window.scrollY), dy = sy - lastY;
      lastY = sy;
      header.classList.toggle('is-scrolled', sy > 8);
      var locked = header.classList.contains('is-menu-open') || (mobileSheet && !mobileSheet.hidden) || header.contains(document.activeElement) && document.activeElement !== document.body;
      if (sy < 120 || locked || Date.now() < holdUntil) { run = 0; setHidden(false); }
      else if (dy !== 0) {
        run = (dy > 0) === (run > 0) ? run + dy : dy;
        if (run >= 14 && sy > 480) setHidden(true);
        else if (run <= -6) setHidden(false);
      }
      var y = Math.round(header.offsetHeight / 2);
      var stack = document.elementsFromPoint ? document.elementsFromPoint(Math.round(window.innerWidth / 2), y) : [];
      var surface = null;
      for (var i = 0; i < stack.length; i++) {
        if (header.contains(stack[i])) continue;
        surface = stack[i].closest('[data-ss-tone], .ss-website-section, .ss-website-footer');
        if (surface) break;
      }
      var dark = !!surface && (surface.matches('.ss-website-section--dark, .ss-website-section--navy, .ss-website-footer') || surface.getAttribute('data-ss-tone') === 'dark');
      header.classList.toggle('is-tone-dark', dark);
    }
    ss.onScroll(updateHeader);
    updateHeader();

    /* ---------- Sliding highlight behind hovered / focused / open item ---------- */
    var indicator = header.querySelector('[data-ss-nav-indicator]');
    var bar = header.querySelector('.ss-website-header__bar');
    function moveIndicator(el) {
      if (!indicator) return;
      if (!el) { indicator.classList.remove('is-visible'); return; }
      var r = el.getBoundingClientRect(), b = bar.getBoundingClientRect();
      indicator.style.width = r.width + 'px';
      indicator.style.setProperty('--ss-x', (r.left - b.left) + 'px');
      if (!indicator.classList.contains('is-visible')) {
        indicator.style.transition = 'none'; indicator.offsetWidth; indicator.style.transition = '';
        indicator.classList.add('is-visible');
      }
    }
    if (indicator) {
      indicator.parentNode.removeChild(indicator); bar.appendChild(indicator);
      header.querySelectorAll('.ss-website-nav__trigger, .ss-website-nav__link').forEach(function (el) {
        el.addEventListener('pointerenter', function () { moveIndicator(el); });
        el.addEventListener('focus', function () { moveIndicator(el); });
      });
      header.querySelector('.ss-website-nav__list').addEventListener('pointerleave', function () {
        var open = header.querySelector('.ss-website-nav__trigger[aria-expanded="true"]');
        moveIndicator(open);
      });
      header.addEventListener('focusout', function (e) { if (!header.contains(e.relatedTarget)) moveIndicator(null); });
    }

    /* ---------- Current page ---------- */
    var here = normalisePath(window.location.pathname);
    document.querySelectorAll('.ss-website-nav a, .ss-website-legal__nav a, .ss-website-footer a, .ss-website-mobile-nav a').forEach(function (a) {
      if (a.origin === window.location.origin && normalisePath(a.pathname) === here && !a.hash) a.setAttribute('aria-current', 'page');
    });

    /* ---------- Mega menus ---------- */
    var triggers = Array.prototype.slice.call(header.querySelectorAll('[data-ss-menu-trigger]'));
    var openTrigger = null;
    var hoverTimer = null;
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function panelFor(trigger) { return document.getElementById(trigger.getAttribute('aria-controls')); }

    function closeMenu(returnFocus) {
      if (!openTrigger) return;
      var trigger = openTrigger;
      trigger.setAttribute('aria-expanded', 'false');
      panelFor(trigger).hidden = true;
      header.classList.remove('is-menu-open');
      openTrigger = null;
      if (indicator && !trigger.matches(':hover')) moveIndicator(null);
      if (returnFocus) trigger.focus();
    }

    function openMenu(trigger, focusFirst) {
      if (openTrigger === trigger) return;
      var wasOpen = !!openTrigger;
      closeMenu(false);
      var panel = panelFor(trigger);
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      header.classList.add('is-menu-open');
      moveIndicator(trigger);
      if (!wasOpen) ss.animateIn(panel);
      openTrigger = trigger;
      if (focusFirst) { var first = panel.querySelector(FOCUSABLE); if (first) first.focus(); }
    }

    triggers.forEach(function (trigger) {
      var panel = panelFor(trigger);
      trigger.addEventListener('click', function () {
        if (openTrigger === trigger) closeMenu(false); else openMenu(trigger, false);
      });
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); openMenu(trigger, true); }
        // Panels sit after all triggers in the DOM, so Tab from an open trigger steps into its panel.
        if (e.key === 'Tab' && !e.shiftKey && openTrigger === trigger) {
          var first = panel.querySelector(FOCUSABLE);
          if (first) { e.preventDefault(); first.focus(); }
        }
      });
      if (canHover) {
        [trigger, panel].forEach(function (el) {
          el.addEventListener('pointerenter', function (e) {
            if (e.pointerType !== 'mouse') return;
            clearTimeout(hoverTimer);
            hoverTimer = setTimeout(function () { openMenu(trigger, false); }, openTrigger ? 0 : 90);
          });
          el.addEventListener('pointerleave', function (e) {
            if (e.pointerType !== 'mouse') return;
            clearTimeout(hoverTimer);
            hoverTimer = setTimeout(function () { if (openTrigger === trigger) closeMenu(false); }, 220);
          });
        });
      }
      // Keep keyboard order logical: Tab out of the panel continues at the next trigger.
      panel.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var items = panel.querySelectorAll(FOCUSABLE);
        var visible = Array.prototype.filter.call(items, function (el) { return el.offsetParent !== null; });
        if (!visible.length) return;
        if (!e.shiftKey && document.activeElement === visible[visible.length - 1]) {
          e.preventDefault();
          closeMenu(false);
          // Continue at whatever follows the trigger in the header (e.g. Pricing), outside every panel.
          var order = Array.prototype.filter.call(header.querySelectorAll(FOCUSABLE), function (el) {
            return !el.closest('.ss-website-mega') && el.offsetParent !== null;
          });
          var next = order[order.indexOf(trigger) + 1];
          (next || trigger).focus();
        } else if (e.shiftKey && document.activeElement === visible[0]) {
          e.preventDefault();
          trigger.focus();
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openTrigger) closeMenu(true);
    });
    document.addEventListener('pointerdown', function (e) {
      if (openTrigger && !e.target.closest('[data-ss-nav]')) closeMenu(false);
    });
    header.addEventListener('focusout', function (e) {
      if (openTrigger && e.relatedTarget && !e.relatedTarget.closest('[data-ss-nav]')) closeMenu(false);
    });

    /* ---------- Mobile navigation sheet ---------- */
    var sheet = header.querySelector('[data-ss-mobile-nav]');
    var openBtn = header.querySelector('[data-ss-mobile-trigger]');
    var closeBtn = sheet && sheet.querySelector('[data-ss-mobile-close]');
    var outside = [document.querySelector('.ss-website-main'), document.querySelector('.ss-website-footer'), header.querySelector('.ss-website-header__bar')];

    function setInert(on) {
      outside.forEach(function (el) { if (!el) return; if (on) el.setAttribute('inert', ''); else el.removeAttribute('inert'); });
    }
    function openSheet() {
      sheet.hidden = false;
      sheet.classList.remove('is-leaving');
      ss.animateIn(sheet);
      openBtn.setAttribute('aria-expanded', 'true');
      html.classList.add('is-nav-locked');
      if (ss.lenis) ss.lenis.stop();
      setInert(true);
      closeBtn.focus();
    }
    function closeSheet(returnFocus) {
      if (sheet.hidden) return;
      openBtn.setAttribute('aria-expanded', 'false');
      html.classList.remove('is-nav-locked');
      if (ss.lenis) ss.lenis.start();
      setInert(false);
      var done = function () { sheet.hidden = true; sheet.classList.remove('is-leaving', 'is-entering'); };
      if (ss.prefersReducedMotion()) done();
      else { sheet.classList.remove('is-entering'); sheet.classList.add('is-leaving'); setTimeout(done, 240); }
      if (returnFocus) openBtn.focus();
    }
    if (sheet && openBtn) {
      openBtn.addEventListener('click', openSheet);
      closeBtn.addEventListener('click', function () { closeSheet(true); });
      sheet.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { closeSheet(true); return; }
        if (e.key !== 'Tab') return;
        var items = Array.prototype.filter.call(sheet.querySelectorAll(FOCUSABLE), function (el) { return el.offsetParent !== null; });
        if (!items.length) return;
        var first = items[0], last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      sheet.addEventListener('click', function (e) { if (e.target.closest('a[href]')) closeSheet(false); });
      window.addEventListener('resize', function () { if (window.innerWidth >= 1024) closeSheet(false); });
    }

    // Restore a clean state when returning through the back/forward cache.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { closeMenu(false); if (sheet) closeSheet(false); }
    });
  });

  /* ---------- Quick-access dock ----------
     Disclosure: the toggle opens a small panel of real destinations. Escape closes (focus returns
     to the toggle), as do an outside click/tap and focus leaving the dock. Tone follows the
     surface underneath (same rule as the header). */
  ss.ready(function () {
    var dock = document.querySelector('[data-ss-dock]');
    if (!dock) return;
    var toggle = dock.querySelector('[data-ss-dock-toggle]');
    var panel = dock.querySelector('.ss-website-dock__panel');
    var scrim = dock.querySelector('[data-ss-dock-scrim]');
    var timer = 0;
    function isOpen() { return dock.classList.contains('is-open'); }
    function open() {
      clearTimeout(timer);
      panel.hidden = false;
      void panel.offsetWidth;
      dock.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', toggle.getAttribute('data-ss-label-close'));
    }
    function close(returnFocus) {
      if (!isOpen()) return;
      dock.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', toggle.getAttribute('data-ss-label-open'));
      timer = setTimeout(function () { panel.hidden = true; }, ss.prefersReducedMotion() ? 0 : 320);
      if (returnFocus) toggle.focus();
    }
    toggle.addEventListener('click', function (e) {
      if (isOpen()) { close(false); return; }
      open();
      // Keyboard activation (detail 0): move into the panel; pointer users keep their place.
      if (e.detail === 0) { var first = panel.querySelector('a'); if (first) first.focus(); }
    });
    if (scrim) scrim.addEventListener('click', function () { close(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(dock.contains(document.activeElement)); });
    document.addEventListener('pointerdown', function (e) { if (isOpen() && !dock.contains(e.target)) close(false); });
    dock.addEventListener('focusout', function (e) { if (isOpen() && e.relatedTarget && !dock.contains(e.relatedTarget)) close(false); });
    // Tone: deepen the disc over dark surfaces (sampled at the toggle's centre).
    var lastTone = null;
    function tone() {
      var r = toggle.getBoundingClientRect();
      var stack = document.elementsFromPoint(r.left + r.width / 2, r.top + r.height / 2), el = null;
      for (var i = 0; i < stack.length; i++) { if (!dock.contains(stack[i])) { el = stack[i]; break; } }
      var surface = el && el.closest('[data-ss-tone], .ss-website-section, .ss-website-footer');
      var dark = !!surface && (surface.matches('.ss-website-section--dark, .ss-website-section--navy, .ss-website-footer') || surface.getAttribute('data-ss-tone') === 'dark');
      if (dark !== lastTone) { lastTone = dark; dock.classList.toggle('is-on-dark', dark); }
    }
    // Phones / tablets: step aside while the visitor scrolls down (content, carousel controls and
    // CTAs stay clear); return on scroll up, near the top and at the end of the page.
    var narrow = window.matchMedia('(max-width: 1023px)'), lastY = window.scrollY, closing = false;
    // The pre-footer form and the footer carry their own actions: the dock never sits over them.
    if ('IntersectionObserver' in window) {
      var seen = new Map();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { seen.set(e.target, e.isIntersecting); });
        closing = Array.from(seen.values()).some(Boolean);
        if (closing && narrow.matches && !isOpen()) dock.classList.add('is-aside');
      }, { rootMargin: '0px 0px -10% 0px' });
      document.querySelectorAll('.ss-website-prefooter, .ss-website-footer').forEach(function (el) { io.observe(el); });
    }
    function aside() {
      var y = window.scrollY, dy = y - lastY;
      if (Math.abs(dy) < 6) return;
      dock.classList.toggle('is-aside', narrow.matches && !isOpen() && ((dy > 0 && y > 200) || closing));
      lastY = y;
    }
    if (ss.onScroll) { ss.onScroll(tone); ss.onScroll(aside); }
    tone();
  });

  /* Log in menu: a disclosure (hover with a short close delay on fine pointers, click, Escape). */
  ss.ready(function () {
    var root = document.querySelector('[data-ss-login]');
    if (!root) return;
    var btn = root.querySelector('[data-ss-login-trigger]'), menu = root.querySelector('[data-ss-login-menu]'), timer = 0;
    var hover = window.matchMedia('(hover: hover) and (pointer: fine)');
    function set(open) { clearTimeout(timer); menu.hidden = !open; btn.setAttribute('aria-expanded', String(open)); }
    btn.addEventListener('click', function () { set(menu.hidden); if (!menu.hidden && !hover.matches) { var a = menu.querySelector('a'); if (a) a.focus(); } });
    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse' && hover.matches) set(true); });
    root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { clearTimeout(timer); timer = setTimeout(function () { set(false); }, 220); } });
    root.addEventListener('focusout', function (e) { if (e.relatedTarget && !root.contains(e.relatedTarget)) set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) { set(false); btn.focus(); } });
    document.addEventListener('pointerdown', function (e) { if (!menu.hidden && !root.contains(e.target)) set(false); });
  });
})();

/* ==== ss-website-localization.js ==== */
/* SkyStruct localization: remember the visitor's language choice.
   Source: switch links point to the counterpart page (/ar/...).
   Shopify: switch buttons submit the native localization form (Shopify owns the localized URL). */
(function () {
  'use strict';
  var ss = window.SkyStruct;
  var html = document.documentElement;

  ss.ready(function () {
    var current = (html.lang || 'en').split('-')[0];

    document.addEventListener('click', function (e) {
      var el = e.target.closest('[data-ss-language-switch]');
      if (el) ss.store.set('lang', el.getAttribute('data-ss-language-switch').split('-')[0]);
    }, true);

    // On a direct entry (no same-site referrer), honour a previously chosen language once per session.
    var preferred = ss.store.get('lang', null);
    var sameSite = false;
    try { sameSite = !!document.referrer && new URL(document.referrer).origin === window.location.origin; } catch (e) { sameSite = false; }
    var checked = false;
    try { checked = window.sessionStorage.getItem('ss-website-lang-checked') === '1'; window.sessionStorage.setItem('ss-website-lang-checked', '1'); } catch (e) { checked = true; }
    if (!preferred || preferred === current || sameSite || checked) return;

    var alt = document.body.getAttribute('data-ss-lang-alt');
    if (alt) { window.location.replace(alt); return; }
    // Shopify: submit with the language button as submitter, so language_code is sent.
    var switcher = document.querySelector('form [data-ss-language-switch^="' + preferred + '"]');
    if (switcher && switcher.form) {
      if (switcher.form.requestSubmit) switcher.form.requestSubmit(switcher); else switcher.click();
    }
  });
})();

/* ==== ss-website-audio.js ==== */
/* SkyStruct audio: two independent channels with persisted preferences.
   1. Background music — home page only, off by default, starts only after a
      user gesture (browser autoplay rules are never bypassed).
   2. Interface SFX — short, quiet feedback on meaningful interactions.
   PLACEHOLDER AUDIO: both channels are synthesised with the Web Audio API
   (original, licence-free). To use approved files instead, set
   data-ss-music-src="<url>" on <body>; see README "Audio". */
(function () {
  'use strict';
  var ss = window.SkyStruct;
  var html = document.documentElement;
  var AC = window.AudioContext || window.webkitAudioContext;

  var DEFAULTS = { music: { on: false, vol: 35 }, sfx: { on: true, vol: 40 } };
  var state = ss.store.get('audio', null) || JSON.parse(JSON.stringify(DEFAULTS));
  if (!state.music || !state.sfx) state = JSON.parse(JSON.stringify(DEFAULTS));

  var ctx = null, master, musicBus, sfxBus, reverb;
  var unlocked = false;
  var music = { playing: false, timer: null, nextAt: 0, index: 0, voices: [], element: null };
  var lastSfx = {};

  function isHome() {
    var page = document.body.getAttribute('data-ss-page') || '';
    return page === 'home' || page === 'index' || /profile/.test(page);
  }
  // The Company Profile presentation owns its sound (one Sound on/off control); null = visitor prefs.
  var forced = null;
  function musicOn() { return forced === null ? state.music.on : forced; }
  function sfxOn() { return forced === null ? state.sfx.on : forced; }
  function save() { ss.store.set('audio', state); }
  function musicGain() { return (state.music.vol / 100) * 0.55; }
  function sfxGain() { return (state.sfx.vol / 100) * 0.9; }

  function ensureContext() {
    if (!AC) return null;
    if (!ctx) {
      ctx = new AC();
      master = ctx.createGain();
      master.connect(ctx.destination);
      musicBus = ctx.createGain(); musicBus.gain.value = 0; musicBus.connect(master);
      sfxBus = ctx.createGain(); sfxBus.gain.value = sfxGain(); sfxBus.connect(master);
      reverb = ctx.createConvolver();
      reverb.buffer = impulse(3.6, 2.4);
      var wet = ctx.createGain(); wet.gain.value = 0.55;
      reverb.connect(wet); wet.connect(musicBus);
    }
    if (ctx.state === 'suspended') ctx.resume();
    return ctx;
  }

  function impulse(seconds, decay) {
    var rate = ctx.sampleRate, len = Math.floor(rate * seconds);
    var buf = ctx.createBuffer(2, len, rate);
    for (var ch = 0; ch < 2; ch++) {
      var data = buf.getChannelData(ch);
      for (var i = 0; i < len; i++) data[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, decay);
    }
    return buf;
  }

  /* ---------- Generative ambient music (placeholder) ---------- */
  // Slow, cool, open-voiced chords: Dmaj9 – Bm9 – Gmaj7#11 – Asus2.
  var CHORDS = [
    [146.83, 220.0, 277.18, 329.63, 369.99],
    [123.47, 185.0, 220.0, 277.18, 293.66],
    [98.0, 146.83, 185.0, 246.94, 277.18],
    [110.0, 164.81, 246.94, 329.63, 369.99],
  ];
  var CHORD_LEN = 9, FADE = 3.2;

  function scheduleChord(at) {
    var notes = CHORDS[music.index % CHORDS.length];
    music.index++;
    var filter = ctx.createBiquadFilter();
    filter.type = 'lowpass'; filter.Q.value = 0.4;
    filter.frequency.setValueAtTime(900, at);
    filter.frequency.linearRampToValueAtTime(1600, at + CHORD_LEN / 2);
    filter.frequency.linearRampToValueAtTime(1000, at + CHORD_LEN + FADE);
    var env = ctx.createGain();
    env.gain.setValueAtTime(0, at);
    env.gain.linearRampToValueAtTime(1, at + FADE);
    env.gain.setValueAtTime(1, at + CHORD_LEN);
    env.gain.linearRampToValueAtTime(0, at + CHORD_LEN + FADE);
    filter.connect(env); env.connect(musicBus); env.connect(reverb);
    var oscs = [];
    notes.forEach(function (f, n) {
      [['sine', -6], ['triangle', 5]].forEach(function (spec) {
        var o = ctx.createOscillator(), g = ctx.createGain();
        o.type = spec[0]; o.frequency.value = f; o.detune.value = spec[1];
        g.gain.value = (spec[0] === 'sine' ? 0.06 : 0.025) * (n === 0 ? 1.2 : 1);
        o.connect(g); g.connect(filter);
        o.start(at); o.stop(at + CHORD_LEN + FADE + 0.1);
        oscs.push(o);
      });
    });
    // A single soft high "glint" two octaves above the root.
    var glint = ctx.createOscillator(), gg = ctx.createGain();
    glint.type = 'sine'; glint.frequency.value = notes[2] * 2;
    gg.gain.setValueAtTime(0, at + 2.5);
    gg.gain.linearRampToValueAtTime(0.012, at + 4.5);
    gg.gain.linearRampToValueAtTime(0, at + 8);
    glint.connect(gg); gg.connect(reverb);
    glint.start(at + 2.5); glint.stop(at + 8.2);
    oscs.push(glint);
    music.voices.push({ end: at + CHORD_LEN + FADE + 0.2, nodes: oscs });
  }

  function tick() {
    if (!music.playing) return;
    while (music.nextAt < ctx.currentTime + 2) { scheduleChord(music.nextAt); music.nextAt += CHORD_LEN; }
    music.voices = music.voices.filter(function (v) { return v.end > ctx.currentTime; });
  }

  function startMusic() {
    if (!musicOn() || !isHome() || !unlocked || music.playing) return;
    if (!ensureContext()) return;
    music.playing = true;
    var src = document.body.getAttribute('data-ss-music-src');
    if (src) {
      if (!music.element) {
        music.element = new Audio(src);
        music.element.loop = true;
        music.element.crossOrigin = 'anonymous';
        ctx.createMediaElementSource(music.element).connect(musicBus);
      }
      music.element.play().catch(function () {});
    } else {
      music.nextAt = ctx.currentTime + 0.1;
      tick();
      music.timer = setInterval(tick, 1000);
    }
    musicBus.gain.cancelScheduledValues(ctx.currentTime);
    musicBus.gain.setValueAtTime(musicBus.gain.value, ctx.currentTime);
    musicBus.gain.linearRampToValueAtTime(musicGain(), ctx.currentTime + 2.5);
  }

  function stopMusic(fast) {
    if (!music.playing || !ctx) return;
    music.playing = false;
    clearInterval(music.timer);
    var t = ctx.currentTime, d = fast ? 0.25 : 1.2;
    musicBus.gain.cancelScheduledValues(t);
    musicBus.gain.setValueAtTime(musicBus.gain.value, t);
    musicBus.gain.linearRampToValueAtTime(0, t + d);
    setTimeout(function () {
      music.voices.forEach(function (v) { v.nodes.forEach(function (n) { try { n.stop(); } catch (e) { /* already stopped */ } }); });
      music.voices = [];
      if (music.element) music.element.pause();
    }, d * 1000 + 50);
  }

  /* ---------- Interface SFX (placeholder synthesis) ---------- */
  function tone(freq, start, dur, type, peak, endFreq) {
    var o = ctx.createOscillator(), g = ctx.createGain();
    o.type = type; o.frequency.setValueAtTime(freq, start);
    if (endFreq) o.frequency.exponentialRampToValueAtTime(endFreq, start + dur);
    g.gain.setValueAtTime(0.0001, start);
    g.gain.exponentialRampToValueAtTime(peak, start + 0.008);
    g.gain.exponentialRampToValueAtTime(0.0001, start + dur);
    o.connect(g); g.connect(sfxBus);
    o.start(start); o.stop(start + dur + 0.02);
  }
  function whoosh(start) {
    var len = Math.floor(ctx.sampleRate * 0.34), buf = ctx.createBuffer(1, len, ctx.sampleRate), d = buf.getChannelData(0);
    for (var i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * Math.sin(Math.PI * i / len);
    var src = ctx.createBufferSource(), bp = ctx.createBiquadFilter(), g = ctx.createGain();
    src.buffer = buf; bp.type = 'bandpass'; bp.Q.value = 0.8;
    bp.frequency.setValueAtTime(500, start); bp.frequency.exponentialRampToValueAtTime(1800, start + 0.3);
    g.gain.value = 0.05;
    src.connect(bp); bp.connect(g); g.connect(sfxBus); src.start(start);
  }
  var SOUNDS = {
    press: function (t) { tone(740, t, 0.09, 'triangle', 0.06); tone(1110, t + 0.012, 0.07, 'sine', 0.03); },
    tick: function (t) { tone(1320, t, 0.04, 'sine', 0.035); },
    tab: function (t) { tone(660, t, 0.07, 'sine', 0.045); tone(990, t + 0.03, 0.07, 'sine', 0.03); },
    open: function (t) { tone(520, t, 0.14, 'sine', 0.04, 820); },
    switch: function (t) { tone(587.33, t, 0.08, 'sine', 0.045); tone(880, t + 0.05, 0.1, 'sine', 0.04); },
    confirm: function (t) { tone(523.25, t, 0.2, 'sine', 0.045); tone(659.25, t + 0.05, 0.2, 'sine', 0.04); tone(783.99, t + 0.1, 0.24, 'sine', 0.035); },
    transition: function (t) { whoosh(t); },
    // Presentation cues: a soft glass movement on a scene change, a faint data signal on a connection.
    scene: function (t) { whoosh(t); tone(392, t + 0.08, 0.5, 'sine', 0.018, 523.25); },
    deep: function (t) { whoosh(t); tone(196, t + 0.05, 0.9, 'sine', 0.02, 146.83); },
    glass: function (t) { whoosh(t); tone(1174.66, t + 0.12, 0.35, 'sine', 0.012, 1567.98); },
    zoom: function (t) { whoosh(t); tone(293.66, t, 0.5, 'triangle', 0.014, 587.33); },
    signal: function (t) { tone(1046.5, t, 0.12, 'sine', 0.014); tone(1568, t + 0.06, 0.16, 'sine', 0.01); },
  };

  /** Presentation sound (Company Profile): on → music + cues; off → both silent. Needs a gesture. */
  ss.presentationAudio = function (on) {
    forced = !!on;
    unlocked = true;
    if (!ensureContext()) return false;
    if (on) startMusic(); else stopMusic(true);
    return true;
  };

  ss.sfx = function (name) {
    if (!sfxOn() || !unlocked || !SOUNDS[name] || !ensureContext()) return;
    var now = performance.now();
    if (lastSfx[name] && now - lastSfx[name] < 45) return;
    lastSfx[name] = now;
    SOUNDS[name](ctx.currentTime + 0.005);
  };

  /* ---------- Controls ---------- */
  function syncControls() {
    document.querySelectorAll('[data-ss-audio-toggle]').forEach(function (btn) {
      var kind = btn.getAttribute('data-ss-audio-toggle');
      var on = !!state[kind].on;
      btn.setAttribute('aria-checked', String(on));
      var label = btn.querySelector('.ss-website-switch__state');
      if (label) label.textContent = label.getAttribute(on ? 'data-ss-on' : 'data-ss-off');
      var row = btn.closest('.ss-website-audio__row');
      if (row) row.classList.toggle('is-on', on);
    });
    document.querySelectorAll('[data-ss-audio-volume]').forEach(function (input) {
      input.value = state[input.getAttribute('data-ss-audio-volume')].vol;
    });
    html.classList.toggle('is-sound-on', !!(state.music.on || state.sfx.on));
  }

  function unlock() {
    if (unlocked) return;
    unlocked = true;
    ensureContext();
    startMusic();
  }

  ss.ready(function () {
    syncControls();
    ['pointerdown', 'keydown', 'touchend'].forEach(function (type) {
      document.addEventListener(type, unlock, { capture: true, passive: true });
    });

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-ss-audio-toggle]');
      if (!toggle) return;
      var kind = toggle.getAttribute('data-ss-audio-toggle');
      state[kind].on = !state[kind].on;
      save(); syncControls();
      unlocked = true; ensureContext();
      if (kind === 'music') { if (state.music.on) startMusic(); else stopMusic(false); }
      else if (state.sfx.on) ss.sfx('confirm');
    });

    var previewTimer = null;
    document.addEventListener('input', function (e) {
      var input = e.target.closest('[data-ss-audio-volume]');
      if (!input) return;
      var kind = input.getAttribute('data-ss-audio-volume');
      state[kind].vol = Number(input.value);
      save(); syncControls();
      if (!ctx) return;
      if (kind === 'music' && music.playing) musicBus.gain.setTargetAtTime(musicGain(), ctx.currentTime, 0.1);
      if (kind === 'sfx') {
        sfxBus.gain.setTargetAtTime(sfxGain(), ctx.currentTime, 0.02);
        clearTimeout(previewTimer);
        previewTimer = setTimeout(function () { ss.sfx('tick'); }, 120);
      }
    });

    // Header popover
    var trigger = document.querySelector('[data-ss-audio-trigger]');
    var panel = document.querySelector('[data-ss-audio-panel]');
    function closePanel(focus) {
      if (!panel || panel.hidden) return;
      panel.hidden = true; trigger.setAttribute('aria-expanded', 'false');
      if (focus) trigger.focus();
    }
    if (trigger && panel) {
      trigger.addEventListener('click', function () {
        if (!panel.hidden) { closePanel(false); return; }
        panel.hidden = false; trigger.setAttribute('aria-expanded', 'true');
        ss.animateIn(panel);
        var first = panel.querySelector('button, input'); if (first) first.focus();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanel(true); });
      document.addEventListener('pointerdown', function (e) { if (!e.target.closest('.ss-website-header__sound')) closePanel(false); });
    }

    document.addEventListener('visibilitychange', function () {
      if (!ctx) return;
      if (document.hidden) ctx.suspend(); else if (state.music.on || state.sfx.on) ctx.resume();
    });
    document.addEventListener('ss:navigate', function () { stopMusic(true); });
    window.addEventListener('pageshow', function (e) { if (e.persisted && music.playing === false && unlocked) startMusic(); });
  });
})();

/* ==== ss-website-transitions.js ==== */
/* SkyStruct page transitions: a short structural wipe between internal pages.
   Real navigations only (no fake SPA). Skipped for reduced motion, new tabs,
   modified clicks, downloads, hashes, external and non-HTTP links. */
(function () {
  'use strict';
  var ss = window.SkyStruct;
  var COVER_MS = 300;

  /* First full load of a session (.is-entry from the head script): lift the brand screen once
     the page has loaded and at least ENTRY_MIN ms have passed since navigation start; never
     later than ENTRY_MAX (the CSS safety lift matches it). */
  var ENTRY_MIN = 3000, ENTRY_MAX = 6500;
  var html = document.documentElement;
  if (html.classList.contains('is-entry')) {
    var done = false;
    var lift = function () {
      if (done) return; done = true;
      setTimeout(function () { html.classList.add('is-entry-done'); }, Math.max(0, ENTRY_MIN - window.performance.now()));
    };
    if (document.readyState === 'complete') lift(); else window.addEventListener('load', lift);
    setTimeout(lift, Math.max(0, ENTRY_MAX - 600 - window.performance.now()));
  }

  ss.ready(function () {
    var overlay = document.querySelector('[data-ss-transition]');
    if (!overlay) return;

    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.target === '_blank' || a.hasAttribute('download') || a.hasAttribute('data-ss-no-transition')) return;
      if (!/^https?:$/.test(a.protocol) || a.origin !== window.location.origin) return;
      var samePage = a.pathname === window.location.pathname && a.search === window.location.search;
      if (samePage) return; // in-page anchors and current page: native behaviour
      if (ss.prefersReducedMotion()) return;

      e.preventDefault();
      var url = a.href;
      document.dispatchEvent(new CustomEvent('ss:navigate', { detail: { url: url } }));
      ss.sfx('transition');
      try { window.sessionStorage.setItem('ss-website-transition', '1'); } catch (err) { /* optional */ }
      overlay.classList.add('is-covering');
      setTimeout(function () { window.location.href = url; }, COVER_MS);
      // Safety: never leave the page covered if navigation is cancelled.
      setTimeout(function () { overlay.classList.remove('is-covering'); }, 2500);
    });

    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        overlay.classList.remove('is-covering');
        document.documentElement.classList.remove('is-arriving');
      }
    });
  });
})();

/* ==== ss-website-interactions.js ==== */
/* SkyStruct interactions: tabs, accordions, record
   sequence, feature filters, legal contents. All hooks are data-ss-* attributes. */
(function () {
  'use strict';
  var ss = window.SkyStruct;

  /* ---------- Tabs (WAI-ARIA pattern, RTL-aware arrow keys) ---------- */
  function initTabs(root) {
    var tabs = Array.prototype.filter.call(root.querySelectorAll('[data-ss-tab]'), function (t) { return t.closest('[data-ss-tabs]') === root; });
    if (!tabs.length) return;
    var vertical = !!root.querySelector('[role="tablist"][aria-orientation="vertical"]');

    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
      root.dispatchEvent(new CustomEvent('ss:tabchange', { detail: { tab: tab } }));
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var rtl = ss.isRtl();
        // A vertical list can render as a horizontal rail (Core capabilities below 1024px): accept both axes.
        var nextKey = rtl ? 'ArrowLeft' : 'ArrowRight';
        var prevKey = rtl ? 'ArrowRight' : 'ArrowLeft';
        if (vertical && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) { nextKey = 'ArrowDown'; prevKey = 'ArrowUp'; }
        var target = null;
        if (e.key === nextKey) target = tabs[(i + 1) % tabs.length];
        else if (e.key === prevKey) target = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') target = tabs[0];
        else if (e.key === 'End') target = tabs[tabs.length - 1];
        if (target) { e.preventDefault(); select(target, true); ss.sfx('tab'); }
      });
      if (tab.hasAttribute('data-ss-tab-hover')) {
        var timer;
        tab.addEventListener('pointerenter', function (e) {
          if (e.pointerType !== 'mouse') return;
          timer = setTimeout(function () { select(tab, false); }, 70);
        });
        tab.addEventListener('pointerleave', function () { clearTimeout(timer); });
      }
    });
  }

  /* ---------- Accordions: animate native <details> (keyboard behaviour stays native) ---------- */
  function initAccordion(details) {
    var summary = details.querySelector('summary');
    if (!summary) return;
    summary.addEventListener('click', function (e) {
      if (ss.prefersReducedMotion() || !details.animate) return;
      e.preventDefault();
      if (details.dataset.ssAnimating) return;
      details.dataset.ssAnimating = '1';
      var start = details.offsetHeight;
      var opening = !details.open;
      if (opening) details.open = true;
      var end = opening ? details.scrollHeight : summary.offsetHeight;
      details.style.overflow = 'hidden';
      var anim = details.animate({ height: [start + 'px', end + 'px'] }, { duration: opening ? 320 : 240, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
      anim.onfinish = function () {
        if (!opening) details.open = false;
        details.style.overflow = '';
        delete details.dataset.ssAnimating;
      };
    });
  }

  /* ---------- Controlled record sequence (home hero) ---------- */
  function playRecord(record) {
    var events = record.querySelectorAll('[data-ss-record-event]');
    if (ss.prefersReducedMotion()) {
      events.forEach(function (e) { e.classList.add('is-shown'); });
      record.classList.add('is-approved');
      return;
    }
    events.forEach(function (ev, i) { setTimeout(function () { ev.classList.add('is-shown'); }, 250 + i * 320); });
    setTimeout(function () { record.classList.add('is-approved'); }, 250 + (events.length - 1) * 320 + 200);
  }

  /* ---------- Feature filter (All / Lite / Pro) ---------- */
  function initFilter(group) {
    var buttons = group.querySelectorAll('[data-ss-filter]');
    var items = group.querySelectorAll('[data-ss-lite]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = btn.getAttribute('data-ss-filter');
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
        items.forEach(function (item) {
          var hide = value !== 'all' && item.getAttribute('data-ss-' + value) === 'no';
          item.classList.toggle('is-filtered-out', hide);
        });
      });
    });
  }

  /* ---------- Legal: contents, scroll-spy, reading progress ---------- */
  function initLegal(content) {
    var list = document.querySelector('[data-ss-toc-list]');
    var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));
    headings.forEach(function (h, i) { if (!h.id) h.id = 'ss-legal-' + (i + 1); });
    if (list && !list.children.length) {
      list.innerHTML = headings.map(function (h) { return '<li><a href="#' + h.id + '"></a></li>'; }).join('');
      Array.prototype.forEach.call(list.querySelectorAll('a'), function (a, i) { a.textContent = headings[i].textContent; });
    }
    var toc = document.querySelector('[data-ss-legal-toc]');
    if (toc && window.innerWidth < 1024) toc.open = false;
    var links = list ? list.querySelectorAll('a') : [];
    if ('IntersectionObserver' in window && links.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + entry.target.id); });
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      headings.forEach(function (h) { io.observe(h); });
    }
    var bar = document.querySelector('[data-ss-reading-progress]');
    if (bar) {
      var update = function () {
        var rect = content.getBoundingClientRect();
        var total = rect.height - window.innerHeight * 0.6;
        var p = Math.min(Math.max(-rect.top / Math.max(total, 1), 0), 1);
        bar.style.setProperty('--ss-progress', p.toFixed(4));
      };
      ss.onScroll(update);
      update();
    }
  }




  /* ---------- Core capabilities: below 1024px the tabs are a horizontal rail; keep the selected pill in view ---------- */
  function initCapselRail(root) {
    var rail = root.querySelector('.ss-website-capsel__selector');
    if (!rail) return;
    root.addEventListener('ss:tabchange', function (e) {
      if (rail.scrollWidth <= rail.clientWidth + 1) return;
      var t = e.detail.tab, r = rail.getBoundingClientRect(), b = t.getBoundingClientRect();
      if (b.left < r.left + 20 || b.right > r.right - 48) rail.scrollBy({ left: (b.left + b.width / 2) - (r.left + r.width / 2), behavior: ss.prefersReducedMotion() ? 'auto' : 'smooth' });
    });
  }

  ss.ready(function () {
    document.querySelectorAll('[data-ss-tabs]').forEach(initTabs);
    document.querySelectorAll('.ss-website-capsel[data-ss-tabs]').forEach(initCapselRail);
    document.querySelectorAll('details[data-ss-accordion]').forEach(initAccordion);
    document.querySelectorAll('[data-ss-filter-group]').forEach(initFilter);
    var legal = document.querySelector('[data-ss-legal-content]');
    if (legal) initLegal(legal);

    ss.onVisible(document.querySelectorAll('[data-ss-record-sequence]'), playRecord, { threshold: 0.2 });

  });
})();

/* ==== ss-website-scenes.js ==== */
/* SkyStruct scenes: scroll stories and product interactions built on the shared
   scroll engine (ss.onScene). Every scene has a static fallback in CSS for
   touch/tablet, reduced motion and no-JS. */
(function () {
  'use strict';
  var ss = window.SkyStruct;
  var desktopMotion = window.matchMedia('(min-width: 1024px) and (prefers-reduced-motion: no-preference)');
  var finePointer = window.matchMedia('(min-width: 1024px) and (hover: hover) and (pointer: fine)');

  /* ---------- The problem: three films ----------
     Desktop (pinned): each film rises over the previous one as a card that opens to full bleed
     (--ss-in), stages index + icon → title → body, then dims while the next film covers it
     (--ss-out). Elsewhere: plain sections whose copy arrives once, on first view. */
  // Any viewport tall enough for a stage (phones in portrait included): inset card → full bleed → hold.
  var filmPinned = window.matchMedia('(min-height: 520px) and (prefers-reduced-motion: no-preference)');
  var VH = window.CSS && CSS.supports && CSS.supports('height', '1svh') ? 'svh' : 'vh';
  function initFilms(films) {
    if (!films.length) return;
    var clamp = function (t) { return Math.min(Math.max(t, 0), 1); };
    var ease = function (t) { return 1 - Math.pow(1 - clamp(t), 3); };
    function steps(film, n) {
      film.classList.toggle('is-s1', n >= 1); film.classList.toggle('is-s2', n >= 2); film.classList.toggle('is-s3', n >= 3);
    }
    /* Reading hold: each chapter stays fully readable (and uncovered) for a scroll distance that
       grows with its own copy length, before the next chapter starts rising over it. A film is
       100vh of stage + 100vh of overlap with the next one + the hold. */
    function sizeFilms() {
      var pinned = filmPinned.matches;
      films.forEach(function (film, i) {
        if (!pinned) { film.style.removeProperty('height'); return; }
        var copy = film.querySelector('.ss-website-film__content');
        var words = copy ? (copy.textContent || '').trim().split(/\s+/).length : 30;
        var hold = Math.round(Math.min(140, Math.max(80, 50 + words * 1.6)));
        // + 50 for the contraction back into a card, which happens before the next chapter rises.
        film.style.height = (i < films.length - 1 ? 250 + hold : 150 + hold) + VH;
      });
    }
    function update() {
      var pinned = filmPinned.matches;
      var vh = window.innerHeight;
      films.forEach(function (film, i) {
        film.classList.toggle('is-pinned', pinned);
        if (!pinned) return;
        var r = film.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        // Phases (deterministic, never overlapping): enter (card → full bleed) · hold ·
        // contract (full bleed → card, before the next chapter moves) · cover (the next card
        // rises while this card fades away). The last chapter contracts, then scrolls off.
        var enter = clamp(1 - r.top / vh);
        var next = films[i + 1], C = 0.5 * vh;
        var edge = next ? next.getBoundingClientRect().top : r.bottom;
        var contract = clamp(1 - (edge - vh) / C);
        var cover = next ? clamp((vh - edge) / vh) : 0;
        film.style.setProperty('--ss-in', ease(enter).toFixed(3));
        film.style.setProperty('--ss-out', ease(contract).toFixed(3));
        film.style.setProperty('--ss-cover', cover.toFixed(3));
        steps(film, enter > 0.9 ? 3 : enter > 0.76 ? 2 : enter > 0.6 ? 1 : 0);
      });
    }
    ss.onScroll(update);
    if (filmPinned.addEventListener) filmPinned.addEventListener('change', function () {
      if (!filmPinned.matches) films.forEach(function (f) { f.style.removeProperty('--ss-in'); f.style.removeProperty('--ss-out'); });
      sizeFilms(); update();
    });
    sizeFilms();
    update();
    ss.onVisible(films, function (film) { if (!filmPinned.matches) steps(film, 3); }, { threshold: 0.15 });
  }

  /* Mobile carousels for peer content ([data-ss-carousel] + [data-ss-carousel-nav]). Below the
     list's breakpoint: scroll-snap track, prev/next, count + progress, keyboard; above it: inert. */
  function initCarousel(list) {
    var nav = document.querySelector('[data-ss-carousel-nav="' + list.id + '"]');
    if (!nav) return;
    var mq = window.matchMedia('(max-width: ' + (parseInt(list.getAttribute('data-ss-carousel'), 10) || 767) + 'px)');
    // data-ss-carousel-items: slides nested one level deeper (e.g. two lists that read as one row).
    var items = Array.prototype.slice.call(list.hasAttribute('data-ss-carousel-items') ? list.querySelectorAll(list.getAttribute('data-ss-carousel-items')) : list.children);
    var btns = nav.querySelectorAll('[data-ss-dir]');
    var count = nav.querySelector('.ss-website-carousel-nav__count b');
    var bar = nav.querySelector('.ss-website-carousel-nav__bar i');
    var ar = document.documentElement.lang === 'ar';
    var digits = function (n) { var s = String(n); return ar ? s.replace(/\d/g, function (d) { return '٠١٢٣٤٥٦٧٨٩'[d]; }) : s; };
    var index = 0, ratios = items.map(function () { return 0; });
    if (count && count.nextSibling) count.nextSibling.textContent = ' / ' + digits(items.length);
    if (items.length < 2) return;
    function render() {
      count.textContent = digits(index + 1);
      bar.style.width = ((index + 1) / items.length * 100).toFixed(1) + '%';
      btns[0].disabled = index === 0; btns[1].disabled = index === items.length - 1;
    }
    function go(i) {
      i = Math.max(0, Math.min(items.length - 1, i));
      items[i].scrollIntoView({ behavior: ss.prefersReducedMotion() ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
    }
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { ratios[items.indexOf(e.target)] = e.intersectionRatio; });
      var best = 0; ratios.forEach(function (r, k) { if (r > ratios[best] + 0.01) best = k; });
      if (best !== index) { index = best; render(); list.dispatchEvent(new CustomEvent('ss:slide', { detail: index })); }
    }, { root: list, threshold: [0, 0.25, 0.5, 0.75, 1] }) : null;
    btns.forEach(function (b) { b.addEventListener('click', function () { go(index + Number(b.getAttribute('data-ss-dir'))); }); });
    list.addEventListener('keydown', function (e) {
      if (!list.classList.contains('is-carousel')) return;
      var back = ss.isRtl() ? 'ArrowRight' : 'ArrowLeft', fwd = ss.isRtl() ? 'ArrowLeft' : 'ArrowRight';
      if (e.key === fwd) { e.preventDefault(); go(index + 1); } else if (e.key === back) { e.preventDefault(); go(index - 1); }
    });
    function apply() {
      var on = mq.matches;
      list.classList.toggle('is-carousel', on);
      nav.hidden = !on;
      if (on) { list.setAttribute('tabindex', '0'); if (io) items.forEach(function (it) { io.observe(it); }); list.dispatchEvent(new CustomEvent('ss:slide', { detail: index })); }
      else { list.removeAttribute('tabindex'); if (io) io.disconnect(); list.dispatchEvent(new CustomEvent('ss:slide', { detail: -1 })); }
      render();
    }
    if (mq.addEventListener) mq.addEventListener('change', apply);
    apply();
  }

  /* Flow diagram pulses (SMIL) run only while the diagram is on screen, never with reduced motion. */
  function initDataflow(flow) {
    var svg = flow.querySelector('.ss-website-dataflow__svg');
    if (!svg || !svg.pauseAnimations) return;
    svg.pauseAnimations();
    if (ss.prefersReducedMotion() || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) svg.unpauseAnimations(); else svg.pauseAnimations();
    }, { threshold: 0.1 }).observe(flow);
  }

  /* ---------- Lite + Pro duo: Lite alone → Pro wipes across → 50/50 split → two cards ----------
     Choreography (scene progress p): 0–.16 Lite alone · .16–.42 Pro wipes in · .42–.52 Pro alone ·
     .52–.70 divider returns to centre · .70–.78 split holds · .78–.96 the split separates into
     two product cards that sit on the page, so the section ends without an edge. */
  function initDuo(duo) {
    var pinned = window.matchMedia('(min-width: 1024px) and (min-height: 680px) and (prefers-reduced-motion: no-preference)');
    var clamp = function (t) { return Math.min(Math.max(t, 0), 1); };
    var ease = function (t) { t = clamp(t); return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; };
    var easeIn = function (t) { t = clamp(t); return t * t * t; };
    var prompt = duo.querySelector('[data-ss-duo-prompt]');
    /* Timeline (progress through the pinned stage):
       0–.14 Lite · .14–.34 Pro wipes across · .34–.42 Pro · .42–.56 settle at 50/50
       .56–.72 both halves resolve into cards inside the 1280px container
       .70–.88 hold: contextual compare prompt · .86–1 cards leave, Lite first, Pro just after
       (both reach the same offset at 1, so the release into normal scrolling is seamless). */
    function wipeAt(p) {
      if (p < 0.14) return 100;
      if (p < 0.34) return 100 - 100 * ease((p - 0.14) / 0.2);
      if (p < 0.42) return 0;
      if (p < 0.56) return 50 * ease((p - 0.42) / 0.14);
      return 50;
    }
    var state = '';
    function setPrompt(on) {
      if (!prompt) return;
      var s = on ? 'on' : 'off';
      if (s !== state) { state = s; duo.setAttribute('data-ss-duo-prompt', s); }
    }
    ss.onScene(duo, function (p) {
      if (!pinned.matches) { setPrompt(true); return; }
      var w = wipeAt(p);
      duo.style.setProperty('--ss-wipe', w.toFixed(2));
      duo.style.setProperty('--ss-exit', ease((p - 0.56) / 0.16).toFixed(3));
      duo.style.setProperty('--ss-leave-lite', easeIn((p - 0.86) / 0.14).toFixed(3));
      duo.style.setProperty('--ss-leave-pro', easeIn((p - 0.895) / 0.105).toFixed(3));
      duo.setAttribute('data-ss-duo-phase', p > 0.52 ? 'compare' : 'intro');
      duo.setAttribute('data-ss-duo-state', w > 99 ? 'lite' : w < 1 ? 'pro' : w > 49 && w < 51 && p > 0.56 ? 'split' : 'moving');
      setPrompt(p > 0.7 && p < 0.9 || (prompt && prompt.contains(document.activeElement)));
    });
    // Keyboard: if focus lands on a layer (or the prompt) that is clipped or hidden at this scroll
    // position, move to the card state, where both products and the prompt are fully visible.
    duo.addEventListener('focusin', function (e) {
      if (!pinned.matches || !(e.target.closest('[data-ss-duo-layer]') || e.target.closest('[data-ss-duo-prompt]'))) return;
      window.setTimeout(function () {
        var r = e.target.getBoundingClientRect();
        var hit = document.elementFromPoint(r.left + r.width / 2, r.top + r.height / 2);
        if (hit && (hit === e.target || e.target.contains(hit)) && duo.getAttribute('data-ss-duo-prompt') === 'on') return;
        var y = duo.getBoundingClientRect().top + window.scrollY + (duo.offsetHeight - window.innerHeight) * 0.79;
        if (ss.lenis) ss.lenis.scrollTo(y, { immediate: true }); else window.scrollTo(0, y);
      }, 160);
    });
  }

  /* ---------- Onboarding: steps travel horizontally while the page scrolls ----------
     The pin lasts exactly as long as the track needs (--ss-track-shift), so scroll distance is
     proportional to the content. Without the wide/motion conditions the row simply swipes. */
  var pinOnboarding = window.matchMedia('(min-width: 1024px) and (min-height: 760px) and (prefers-reduced-motion: no-preference)');
  function initOnboarding(scene) {
    var viewport = scene.querySelector('.ss-website-onboarding__viewport');
    var track = scene.querySelector('[data-ss-onboarding-track]');
    if (!viewport || !track) return;
    function measure() {
      var on = pinOnboarding.matches;
      scene.classList.toggle('is-pinned', on);
      // Swipe row is keyboard-scrollable; the pinned track is driven by page scroll instead.
      if (on) viewport.removeAttribute('tabindex'); else viewport.setAttribute('tabindex', '0');
      var shift = on ? Math.max(0, track.scrollWidth - viewport.clientWidth) : 0;
      scene.style.setProperty('--ss-track-shift', shift + 'px');
    }
    measure();
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(viewport);
    if (pinOnboarding.addEventListener) pinOnboarding.addEventListener('change', measure);
    ss.onScene(scene);
  }

  /* ---------- About · who we are: word-by-word reveal driven by scroll ----------
     Words are wrapped here (the copy stays one translatable string). Pinned on wide screens with
     motion; elsewhere the reveal follows the paragraph through the viewport. */
  var aboutPin = window.matchMedia('(min-width: 1024px) and (min-height: 680px) and (prefers-reduced-motion: no-preference)');
  var clamp01 = function (v) { return Math.min(Math.max(v, 0), 1); };
  function initWho(section) {
    var text = section.querySelector('[data-ss-words]');
    if (!text) return;
    var words = [];
    Array.prototype.slice.call(text.childNodes).forEach(function (node) {
      if (node.nodeType !== 3) return;
      var frag = document.createDocumentFragment();
      node.textContent.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
        var w = document.createElement('span'); w.className = 'ss-website-who__word'; w.textContent = part; words.push(w); frag.appendChild(w);
      });
      text.replaceChild(frag, node);
    });
    if (ss.prefersReducedMotion()) { words.forEach(function (w) { w.classList.add('is-on'); }); return; }
    var shown = -1;
    function reveal(f) {
      var n = Math.round(clamp01(f) * words.length);
      if (n === shown) return;
      shown = n;
      for (var i = 0; i < words.length; i++) words[i].classList.toggle('is-on', i < n);
    }
    ss.onScene(section, function (p) { if (aboutPin.matches) reveal((p - 0.04) / 0.72); });
    ss.onScroll(function () {
      if (aboutPin.matches) return;
      var r = text.getBoundingClientRect(), vh = window.innerHeight;
      reveal((vh * 0.88 - r.top) / (r.height + vh * 0.35));
    });
  }

  /* ---------- About · purpose: intro → Mission → Vision (pinned, wide screens with motion) ---------- */
  function initPurpose(section) {
    ss.onScene(section, function (p) {
      if (!aboutPin.matches) return;
      section.style.setProperty('--ss-intro-out', clamp01((p - 0.06) / 0.18).toFixed(3));
      section.style.setProperty('--ss-card-in', clamp01((p - 0.16) / 0.16).toFixed(3));
      section.style.setProperty('--ss-swap', clamp01((p - 0.5) / 0.24).toFixed(3));
    });
  }

  /* ---------- C.L.I.C.: the section's identity colour follows the selected area ---------- */
  function initClic(root) {
    var tabs = root.querySelector('[data-ss-tabs]');
    if (tabs) tabs.addEventListener('ss:tabchange', function (e) {
      var cat = e.detail.tab.getAttribute('data-ss-clic-tab');
      if (cat) root.setAttribute('data-ss-clic', cat);
    });
  }

  /* ---------- Trust marquee: no compositing work while it is off screen ---------- */
  function initMarquee(el) {
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) { el.classList.toggle('is-paused', !entries[0].isIntersecting); }).observe(el);
  }

  /* ---------- Atmosphere: slow shapes with a gentle pointer response ---------- */
  /* ---------- Backdrop: scroll parallax + pointer depth, paused offscreen ---------- */
  function initBackdrop(bd) {
    var host = bd.parentElement;
    var still = ss.prefersReducedMotion();
    new IntersectionObserver(function (entries) {
      bd.classList.toggle('is-paused', !entries[0].isIntersecting);
    }).observe(host);
    if (still) return;
    var layers = Array.prototype.slice.call(bd.querySelectorAll('[data-ss-parallax]'));
    ss.onScene(host, function (p) {
      var h = host.offsetHeight;
      layers.forEach(function (l) {
        var f = parseFloat(l.getAttribute('data-ss-parallax'));
        l.style.transform = 'translate3d(0,' + ((p - 0.5) * f * h * 0.5).toFixed(1) + 'px,0)';
      });
    }, 'view');
    if (!finePointer.matches) return;
    var shapes = Array.prototype.slice.call(bd.querySelectorAll('[data-ss-depth]'));
    var tx = 0, ty = 0, x = 0, y = 0, running = false;
    function frame() {
      x += (tx - x) * 0.06; y += (ty - y) * 0.06;
      shapes.forEach(function (l) {
        var d = parseFloat(l.getAttribute('data-ss-depth'));
        l.style.translate = (x * d * 28).toFixed(1) + 'px ' + (y * d * 18).toFixed(1) + 'px';
      });
      if (!bd.classList.contains('is-paused') && Math.abs(tx - x) + Math.abs(ty - y) > 0.002) window.requestAnimationFrame(frame); else running = false;
    }
    host.addEventListener('pointermove', function (e) {
      var r = host.getBoundingClientRect();
      tx = (e.clientX - r.left) / r.width * 2 - 1;
      ty = (e.clientY - r.top) / r.height * 2 - 1;
      if (!running) { running = true; window.requestAnimationFrame(frame); }
    }, { passive: true });
  }

  /* ---------- Story sections: the visual advances with the reason in focus ---------- */
  function initOutcomes(section) {
    var items = Array.prototype.slice.call(section.querySelectorAll('[data-ss-outcome]'));
    var visual = section.querySelector('[data-ss-story-visual]');
    if (!items.length || !visual) return;
    var rows = visual.querySelectorAll('.ss-website-transform__row');
    var scraps = visual.querySelectorAll('.ss-website-transform__scrap');
    var screens = visual.querySelectorAll('[data-ss-story-image]');
    function setStep(n) {
      items.forEach(function (it, i) { it.classList.toggle('is-active', i === n); });
      visual.setAttribute('data-ss-step', n);
      section.style.setProperty('--ss-step', n);
      Array.prototype.forEach.call(rows, function (r, i) { r.classList.toggle('is-on', i <= n); r.classList.toggle('is-latest', i === n); });
      visual.style.setProperty('--ss-done', Math.min(n + 1, rows.length));
      Array.prototype.forEach.call(scraps, function (r, i) { r.classList.toggle('is-cleared', i <= n); });
      visual.classList.toggle('is-complete', n >= items.length - 1);
      Array.prototype.forEach.call(screens, function (img, i) { img.classList.toggle('is-active', i === Math.min(n, screens.length - 1)); });
    }
    section.classList.add('is-story');
    setStep(0);
    var list = items[0].parentElement;
    // Phones / tablets: the reasons are a one-at-a-time carousel under the visual; the slide in
    // view drives the visual. Desktop: scroll position drives it (sticky visual).
    list.addEventListener('ss:slide', function (e) { if (e.detail >= 0) setStep(e.detail); });
    var io = new IntersectionObserver(function (entries) {
      if (list.classList.contains('is-carousel')) return;
      entries.forEach(function (e) { if (e.isIntersecting) setStep(items.indexOf(e.target)); });
    }, { rootMargin: '-45% 0px -45% 0px' });
    items.forEach(function (it) { io.observe(it); });
  }

  /* ---------- Sliding puck behind the selected tab of a rail ---------- */
  function initPuck(rail) {
    var puck = rail.querySelector('.ss-website-segmented__puck');
    function place() {
      var sel = rail.querySelector('[aria-selected="true"]');
      if (!sel || !puck) return;
      puck.style.setProperty('--ss-puck-x', sel.offsetLeft + 'px');
      puck.style.setProperty('--ss-puck-y', sel.offsetTop + 'px');
      puck.style.setProperty('--ss-puck-w', sel.offsetWidth + 'px');
      puck.style.setProperty('--ss-puck-h', sel.offsetHeight + 'px');
    }
    new MutationObserver(place).observe(rail, { attributes: true, subtree: true, attributeFilter: ['aria-selected'] });
    // Re-measure when an option changes size (web fonts arriving, language, breakpoints).
    if ('ResizeObserver' in window) { var ro = new ResizeObserver(place); rail.querySelectorAll('[role="tab"]').forEach(function (t) { ro.observe(t); }); }
    else window.addEventListener('resize', place);
    place();
  }

  /* ---------- Page environment: clouds drift at their own depth as the page scrolls ---------- */
  function initEnvironment(env) {
    // The layer is positioned in % of the page height, which keeps changing while the HTML streams
    // in and web fonts swap. It stays hidden until both have settled, then fades in, so it never
    // registers as layout shift (hidden elements are not counted).
    var reveal = function () { env.classList.add('is-ready'); };
    var fonts = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    Promise.race([fonts, new Promise(function (r) { setTimeout(r, 1500); })]).then(function () { window.requestAnimationFrame(reveal); });
    if (ss.prefersReducedMotion()) return;
    var clouds = Array.prototype.slice.call(env.querySelectorAll('[data-ss-env-speed]'));
    function update() {
      var vh = window.innerHeight;
      clouds.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -vh || r.top > vh * 2) return; // only those near the viewport
        var centre = r.top + r.height / 2 - vh / 2 - (parseFloat(el.getAttribute('data-ss-y')) || 0);
        var y = -centre * parseFloat(el.getAttribute('data-ss-env-speed'));
        el.setAttribute('data-ss-y', y.toFixed(1));
        el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
      });
    }
    ss.onScroll(update);
    update();
  }

  /* ---------- Masked word reveal for display headings ([data-ss-split]) ----------
     Words only (never letters), so Arabic shaping is untouched. A visually hidden
     copy keeps the accessible text; the split words are presentational. */
  function initSplit(el) {
    var text = el.textContent.replace(/\s+/g, ' ').trim();
    if (!text) return;
    var i = 0;
    var holder = document.createElement('span');
    holder.textContent = text;
    el.innerHTML = '<span class="ss-website-visually-hidden">' + holder.innerHTML + '</span>' + text.split(' ').map(function (w) {
      var span = document.createElement('span');
      span.textContent = w;
      return '<span class="ss-website-split__word" aria-hidden="true"><span class="ss-website-split__inner" style="--ss-i:' + (i++) + '">' + span.innerHTML + '</span></span>';
    }).join(' ');
    el.classList.add('is-split');
    if (el.getAttribute('data-ss-split') === 'scroll') el.classList.add('is-split-scroll');
  }

  /* ---------- Product video: load + play only while on screen; poster only with reduced motion ---------- */
  function initVideo(video) {
    if (ss.prefersReducedMotion() || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        if (video.preload !== 'auto') { video.preload = 'auto'; video.load(); }
        var p = video.play(); if (p && p.catch) p.catch(function () {});
      } else video.pause();
    }, { rootMargin: '120px 0px' }).observe(video);
  }

  ss.ready(function () {
    initFilms(Array.prototype.slice.call(document.querySelectorAll('[data-ss-film]')));
    document.querySelectorAll('[data-ss-dataflow]').forEach(initDataflow);
    document.querySelectorAll('[data-ss-carousel][id]').forEach(initCarousel);
    document.querySelectorAll('[data-ss-video]').forEach(initVideo);
    document.querySelectorAll('[data-ss-clic-root]').forEach(initClic);
    document.querySelectorAll('[data-ss-onboarding]').forEach(initOnboarding);
    document.querySelectorAll('[data-ss-who]').forEach(initWho);
    document.querySelectorAll('[data-ss-purpose]').forEach(initPurpose);
    ss.onVisible(document.querySelectorAll('[data-ss-capai]'), function (el) { el.classList.add('is-played'); }, { threshold: 0.15 });
    document.querySelectorAll('[data-ss-duo]').forEach(initDuo);
    document.querySelectorAll('[data-ss-marquee]').forEach(initMarquee);
    document.querySelectorAll('[data-ss-puck-rail]').forEach(initPuck);
    document.querySelectorAll('[data-ss-outcomes]').forEach(initOutcomes);
    document.querySelectorAll('[data-ss-backdrop]').forEach(initBackdrop);
    document.querySelectorAll('[data-ss-environment]').forEach(initEnvironment);
    if (!ss.prefersReducedMotion()) document.querySelectorAll('[data-ss-split]').forEach(initSplit);
  });
})();

/* ==== ss-website-immersive.js ==== */
/* Immersive product chapter (home): surface expansion and the One connected flow Lite ⇄ Pro
   switch. The product-UI scenes inside each tier are run by product-ui.js. */
(function () {
  'use strict';
  var ss = window.SkyStruct;
  var clamp = function (v) { return Math.min(Math.max(v, 0), 1); };
  var ease = function (t) { return t * t * (3 - 2 * t); };

  /* Inset card → full bleed → inset card, from the chapter's position in the viewport. */
  function initExpansion(section) {
    if (ss.prefersReducedMotion()) return;
    var last = -1;
    ss.onScroll(function () {
      var r = section.getBoundingClientRect(), vh = window.innerHeight;
      if (r.bottom < -vh || r.top > vh * 2) return;
      var enter = clamp((vh - r.top) / (vh * 0.85));
      var leave = clamp(r.bottom / (vh * 0.85));
      var e = Math.round(ease(Math.min(enter, leave)) * 1000) / 1000;
      if (e !== last) { last = e; section.style.setProperty('--ss-expand', e); }
    });
  }

  /* Lite ⇄ Pro: one active tier; the hidden one is inert. Announces the shown tier (ss:panel). */
  function initShowcase(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ss-showcase-tab]'));
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-ss-showcase-tier]'));
    function select(tab, focus) {
      var name = tab.getAttribute('data-ss-showcase-tab');
      tabs.forEach(function (t) { var on = t === tab; t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; });
      if (focus) tab.focus();
      tiers.forEach(function (tier) {
        var on = tier.getAttribute('data-ss-showcase-tier') === name;
        tier.classList.toggle('is-active', on);
        if (on) {
          tier.removeAttribute('inert');
          tier.dispatchEvent(new CustomEvent('ss:panel', { bubbles: true }));
        } else tier.setAttribute('inert', '');
      });
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { if (tab.getAttribute('aria-selected') !== 'true') select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!dir) return;
        if (ss.isRtl()) dir = -dir;
        e.preventDefault();
        select(tabs[(i + dir + tabs.length) % tabs.length], true);
      });
    });
  }

  ss.ready(function () {
    document.querySelectorAll('[data-ss-immersive]').forEach(initExpansion);
    document.querySelectorAll('[data-ss-showcase]').forEach(initShowcase);
  });
})();

/* ==== ss-website-product-ui.js ==== */
/* Product-UI compositions (home).
   - Loops ([data-ss-pui]) run only while the composition is on screen (.is-live); CSS owns the motion
     and its reduced-motion fallback (the static final state).
   - One connected flow map ([data-ss-flowmap]): thin connectors from each approved step to the part of
     the UI it describes ([data-ss-flow-link] → [data-ss-anchor]); desktop only, redrawn on resize and
     when the Lite / Pro tier changes. */
(function () {
  'use strict';
  var ss = window.SkyStruct;
  var NS = 'http://www.w3.org/2000/svg';
  var wide = window.matchMedia('(min-width: 1180px)');  // = the flowmap 3-column breakpoint (product-ui.css)

  function initLoops(figs) {
    if (!figs.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.classList.toggle('is-live', e.isIntersecting); });
    }, { rootMargin: '0px 0px 15% 0px', threshold: 0.05 });
    figs.forEach(function (f) { io.observe(f); });
  }

  /* Connector routing: each step card → its panel in the horizontal screen. Left cards enter
     the screen's left edge, right cards its right edge; targets are ordered top-to-bottom in
     the same order as the cards, so paths never cross. Geometry from live layout boxes. */
  function drawMap(map, animate) {
    var svg = map.querySelector('.ss-website-flowmap__lines');
    if (!svg) return;
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    if (!wide.matches || map.closest('[inert]')) return;
    var box = map.getBoundingClientRect();
    svg.setAttribute('viewBox', '0 0 ' + box.width.toFixed(1) + ' ' + box.height.toFixed(1));
    map.querySelectorAll('[data-ss-flow-link]').forEach(function (item) {
      var anchor = map.querySelector('[data-ss-anchor="' + item.getAttribute('data-ss-flow-link') + '"]');
      if (!anchor) return;
      var a = item.getBoundingClientRect(), b = anchor.getBoundingClientRect();
      var fromLeft = a.left + a.width / 2 < b.left + b.width / 2;
      var ax = (fromLeft ? a.right : a.left) - box.left, ay = a.top + a.height / 2 - box.top;
      var bx = (fromLeft ? b.left : b.right) - box.left, by = b.top + Math.min(b.height / 2, 26) - box.top;
      var dx = Math.abs(bx - ax) * 0.5 * (fromLeft ? 1 : -1);
      var path = document.createElementNS(NS, 'path');
      path.setAttribute('pathLength', '1');
      path.setAttribute('d', 'M' + ax.toFixed(1) + ',' + ay.toFixed(1) + ' C' + (ax + dx).toFixed(1) + ',' + ay.toFixed(1) + ' ' + (bx - dx).toFixed(1) + ',' + by.toFixed(1) + ' ' + bx.toFixed(1) + ',' + by.toFixed(1));
      var dot = document.createElementNS(NS, 'circle');
      dot.setAttribute('cx', bx.toFixed(1)); dot.setAttribute('cy', by.toFixed(1)); dot.setAttribute('r', '3.5');
      svg.appendChild(path); svg.appendChild(dot);
      item._ssLink = [path, dot, anchor];
    });
    if (animate) { svg.classList.remove('is-drawing'); svg.getBoundingClientRect(); svg.classList.add('is-drawing'); }
  }
  function highlight(item, on) {
    item.classList.toggle('is-active', on);
    (item._ssLink || []).forEach(function (el) { el.classList.toggle('is-active', on); });
  }

  /* Below 1180px the steps are a one-at-a-time carousel: the screen pans / zooms onto the panel
     the active step describes (transform-free offsets inside the scaled screen). */
  function initFocus(map) {
    var steps = map.querySelector('[data-ss-carousel]');
    var screen = map.querySelector('.ss-website-flowui');
    if (!steps || !screen) return;
    var items = Array.prototype.slice.call(steps.querySelectorAll('[data-ss-flow-link]'));
    var canvas = screen.querySelector('.ss-website-pui__scaled');
    function focus(n) {
      screen.querySelectorAll('[data-ss-anchor].is-focus').forEach(function (p) { p.classList.remove('is-focus'); });
      if (n < 0 || !items[n]) { screen.classList.remove('is-focusing'); return; }
      var panel = screen.querySelector('[data-ss-anchor="' + items[n].getAttribute('data-ss-flow-link') + '"]');
      var art = canvas && canvas.firstElementChild;
      if (!panel || !art) return;
      var x = 0, y = 0, el = panel;
      while (el && el !== art) { x += el.offsetLeft; y += el.offsetTop; el = el.offsetParent; }
      screen.style.setProperty('--ss-fx', ((x + panel.offsetWidth / 2) / art.offsetWidth * 100).toFixed(1) + '%');
      screen.style.setProperty('--ss-fy', ((y + panel.offsetHeight / 2) / art.offsetHeight * 100).toFixed(1) + '%');
      panel.classList.add('is-focus');
      screen.classList.add('is-focusing');
    }
    // The screen opens as the whole dashboard; it zooms only once the visitor moves through the
    // steps (so the zoom reads as "this is where that happens"). A tier switch resets the overview.
    var current = 0, engaged = false;
    var engage = function () { engaged = true; };
    ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(function (t) { steps.addEventListener(t, engage, { passive: true }); });
    var nav = map.querySelector('.ss-website-carousel-nav');
    if (nav) nav.addEventListener('click', engage, true);
    steps.addEventListener('ss:slide', function (e) { current = e.detail; focus(engaged ? current : -1); });
    document.addEventListener('ss:panel', function () { engaged = false; focus(-1); });
  }

  function initMaps(maps) {
    if (!maps.length) return;
    maps.forEach(initFocus);
    var redraw = function (animate) { maps.forEach(function (m) { drawMap(m, animate === true); }); };
    // Observe the map and its screen column: the columns can settle without the map changing size.
    if ('ResizeObserver' in window) maps.forEach(function (m) { var ro = new ResizeObserver(function () { drawMap(m); }); ro.observe(m); var ctr = m.querySelector('.ss-website-flowmap__center'); if (ctr) ro.observe(ctr); });
    window.addEventListener('resize', function () { redraw(); });
    if (wide.addEventListener) wide.addEventListener('change', function () { redraw(); });
    // Lite / Pro switch: recompute after the panel settles, and draw the new lines in quickly.
    document.addEventListener('ss:panel', function () { window.setTimeout(function () { redraw(true); }, 60); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { redraw(); });
    maps.forEach(function (m) {
      m.querySelectorAll('[data-ss-flow-link]').forEach(function (item) {
        item.addEventListener('mouseenter', function () { highlight(item, true); });
        item.addEventListener('mouseleave', function () { highlight(item, false); });
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { drawMap(m, true); io.disconnect(); } }, { threshold: 0.3 });
        io.observe(m);
      }
    });
    redraw();
  }

  /* Shared fit ([data-ss-fit="<design px>"]): below the design width the first child is drawn at
     that width and scaled; the wrapper reserves the scaled height. Re-measured on resize and
     whenever the drawn content changes height (images, loops). */
  function initFit(els) {
    if (!els.length || !('ResizeObserver' in window)) return;
    function apply(el) {
      var design = parseFloat(el.getAttribute('data-ss-fit')), inner = el.firstElementChild;
      if (!design || !inner) return;
      var fitting = el.classList.contains('is-fit');
      var w = el.clientWidth + (fitting ? 0 : 0);
      if (!w) return;
      if (w >= design - 0.5) {
        if (fitting) { el.classList.remove('is-fit'); el.style.height = ''; el.style.removeProperty('--ss-fit'); }
        return;
      }
      var k = w / design;
      if (!fitting) { el.style.setProperty('--ss-fit-w', design); el.classList.add('is-fit'); }
      el.style.setProperty('--ss-fit', k.toFixed(4));
      el.style.height = Math.ceil(inner.offsetHeight * k) + 'px';
    }
    var ro = new ResizeObserver(function (entries) {
      entries.forEach(function (e) { apply(e.target.hasAttribute('data-ss-fit') ? e.target : e.target.parentElement); });
    });
    els.forEach(function (el) { ro.observe(el); if (el.firstElementChild) ro.observe(el.firstElementChild); apply(el); });
  }

  ss.ready(function () {
    initFit(Array.prototype.slice.call(document.querySelectorAll('[data-ss-fit]')));
    initLoops(Array.prototype.slice.call(document.querySelectorAll('[data-ss-pui], [data-ss-loop]')));
    initMaps(Array.prototype.slice.call(document.querySelectorAll('[data-ss-flowmap]')));
  });
})();

/* Home hero media — one state machine:
   init → intro (official logo film, once per page load) → white (deliberate reset) →
   assembling (CSS choreography, ~2 s) → live (CSS ambient loop, indefinite).
   Intro failure (error, play() rejected, or no data in time) → white → assembling → live.
   Reduced motion → static (final dashboard, no film, no loops). Offscreen / hidden tab →
   the ambient loop pauses (CSS + SVG); the 6 s intro is never paused, so it cannot stall. Each timed step is one entry in DURATIONS, driven by a single timer. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ss-hero-media]');
  if (!root) return;
  var video = root.querySelector('[data-ss-hero-intro]');
  var svg = null; // connectors are static paths (no SMIL)
  var DURATIONS = { white: 320, assembling: 2100 }; // ms each timed state lasts before advancing
  var NEXT = { white: 'assembling', assembling: 'live' };
  var state = 'init', timer = 0, started = false;

  function set(next) {
    if (state === next) return;
    state = next;
    root.setAttribute('data-state', next);
    window.clearTimeout(timer);
    if (DURATIONS[next]) timer = window.setTimeout(function () { set(NEXT[next]); }, DURATIONS[next]);
    if (next === 'assembling' || next === 'static') scene('a');
    if (next === 'live') cycle();
  }

  /* Scenes: one app navigating between modules (A project dashboard · B schedule forecast ·
     C Lite handover). Connectors only join related elements; geometry is measured in layout
     space (offsets, transform-free), so the hero tilt and module animations never skew it. */
  var SCENES = ['a', 'b', 'c'], SCENE_MS = 5500, sceneTimer = 0, current = 'a', paused = false;
  var LINKS = {
    a: [['request', 'drawings']],
    b: [['insight', 'chart']],
    c: [['issue', 'issues'], ['milestone', 'milestones']]
  };
  var links = root.querySelector('.ss-website-hero-links');
  function offsetIn(el, anc) { var x = 0, y = 0; while (el && el !== anc) { x += el.offsetLeft; y += el.offsetTop; el = el.offsetParent; } return { x: x, y: y }; }
  function drawLinks() {
    if (!links) return;
    links.classList.remove('is-drawn');
    links.innerHTML = '';
    if (window.matchMedia('(max-width: 767px)').matches) return;
    var W = root.offsetWidth, H = root.offsetHeight;
    links.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    var screen = root.querySelector('.ss-website-hero-screen[data-scene="' + current + '"] > .ss-website-pui__scaled');
    var inner = screen && screen.firstElementChild;
    if (!inner) return;
    var k = screen.offsetWidth / inner.offsetWidth;
    var so = offsetIn(screen, root);
    var html = '';
    (LINKS[current] || []).forEach(function (pair) {
      var f = root.querySelector('[data-ss-hero-float="' + pair[0] + '"]');
      var a = inner.querySelector('[data-ss-hero-anchor="' + pair[1] + '"]');
      if (!f || !a || !f.offsetWidth) return;
      var fo = offsetIn(f, root), ao = offsetIn(a, inner);
      var ax0 = so.x + ao.x * k, ay = so.y + (ao.y + a.offsetHeight / 2) * k, ax1 = ax0 + a.offsetWidth * k;
      var fromRight = fo.x + f.offsetWidth / 2 > W / 2;
      var fx = fromRight ? fo.x : fo.x + f.offsetWidth;
      var fy = Math.max(fo.y + 20, Math.min(fo.y + f.offsetHeight - 20, ay));
      var tx = fromRight ? Math.min(ax1, fx - 30) : Math.max(ax0, fx + 30);
      var mid = (fx + tx) / 2;
      html += '<path pathLength="1" d="M' + fx.toFixed(1) + ' ' + fy.toFixed(1) + ' C' + mid.toFixed(1) + ' ' + fy.toFixed(1) + ' ' + mid.toFixed(1) + ' ' + ay.toFixed(1) + ' ' + tx.toFixed(1) + ' ' + ay.toFixed(1) + '"/><circle r="4" cx="' + tx.toFixed(1) + '" cy="' + ay.toFixed(1) + '"/>';
    });
    links.innerHTML = html;
    window.requestAnimationFrame(function () { links.getBoundingClientRect(); links.classList.add('is-drawn'); });
  }
  function scene(s) { current = s; root.setAttribute('data-scene', s); window.setTimeout(drawLinks, 40); }
  function cycle() {
    window.clearTimeout(sceneTimer);
    sceneTimer = window.setTimeout(function next() {
      if (!paused) scene(SCENES[(SCENES.indexOf(current) + 1) % SCENES.length]);
      sceneTimer = window.setTimeout(next, SCENE_MS);
    }, SCENE_MS);
  }
  window.addEventListener('resize', function () { if (state === 'assembling' || state === 'live' || state === 'static') drawLinks(); });
  function introDone() { if (state === 'init' || state === 'intro') set('white'); }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !video) { if (video) video.preload = 'none'; started = true; set('static'); }
  function start(force) {
    if (started) return;
    // First visit of a session: wait for the brand screen to lift so the film is actually seen
    // (bounded: never wait longer than 4.5 s).
    var html = document.documentElement;
    if (!force && html.classList.contains('is-entry') && !html.classList.contains('is-entry-done')) {
      if (!start.waiting) {
        start.waiting = true;
        var go = function () { start(true); };
        new MutationObserver(function (m, obs) { if (html.classList.contains('is-entry-done')) { obs.disconnect(); window.setTimeout(go, 250); } }).observe(html, { attributes: true, attributeFilter: ['class'] });
        window.setTimeout(go, 4500);
      }
      return;
    }
    started = true;
    set('intro');
    video.addEventListener('ended', introDone, { once: true });
    video.addEventListener('error', introDone, { once: true });
    var source = video.querySelector('source'); if (source) source.addEventListener('error', introDone, { once: true });
    // Fallback only if the film never starts (blocked autoplay, slow network): not a duration guess.
    var guard = window.setTimeout(function () { if (video.readyState < 2 || video.paused) introDone(); }, 3500);
    video.addEventListener('playing', function () { window.clearTimeout(guard); }, { once: true });
    var p = video.play();
    if (p && p.catch) p.catch(function () { window.clearTimeout(guard); introDone(); });
  }

  function pause(on) {
    paused = on;
    root.classList.toggle('is-paused', on);
    if (svg && svg.pauseAnimations) { if (on) svg.pauseAnimations(); else svg.unpauseAnimations(); }
  }
  // Visibility is measured directly (not cached from observer entries) so a missed observer
  // callback can never leave the dashboard paused while it is on screen.
  var raf = 0;
  function check() {
    raf = 0;
    var r = root.getBoundingClientRect();
    var visible = r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight);
    if (visible) start();
    pause(!visible || document.hidden);
  }
  function schedule() { if (!raf) raf = window.requestAnimationFrame(check); }
  if ('IntersectionObserver' in window) new IntersectionObserver(schedule, { threshold: 0 }).observe(root);
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  document.addEventListener('visibilitychange', schedule);
  check();
})();

/* ==== ss-website-globe.js ==== */
/* SkyStruct globe: an interactive, rotatable dotted world.
   - WebGL renders ~15k land points on a lit CSS sphere; a 2D canvas fallback draws
     the same projection when WebGL is unavailable.
   - Opens on MENA, auto-rotates slowly, drags (yaw + pitch) with inertia.
   - Qatar is emphasised quietly: brighter nearby land, a static ring and a label.
     Thin static arcs reach the commercial-coverage markets. No pulses.
   - Lazy (data loads near the viewport), pauses offscreen and in hidden tabs,
     still for reduced motion (dragging remains available).
   - Horizon mode (data-ss-globe-mode="horizon"): the globe is the section's environment.
     Doha faces the viewer near the top of the visible cap; the camera drifts with scroll
     instead of auto-rotating; drags spring back. Paths to the commercial-coverage markets
     draw in once, then an occasional light travels outward from Doha. Unlabelled, dashed,
     very faint paths to wider hubs are illustrative only (no market claim).
   - Simple mode (data-ss-globe-simple): no paths and no market labels — a quiet, unlabelled
     Qatar origin marker and a repeating expansion pulse: a signature-blue wave lights the land
     as it travels outward from Qatar across the sphere (with a faint geodesic ring), fades,
     and repeats. The globe sways gently around MENA instead of rotating away from it; drags
     spring back. Reduced motion: a still, softly lit MENA. Tone (data-ss-globe-tone="light")
     draws blue land on a pale sphere for light sections. */
(function () {
  'use strict';
  var ss = window.SkyStruct;
  var RAD = Math.PI / 180;
  var HUB = [51.53, 25.29]; // Doha
  var LINKS = [[46.68, 24.71], [50.58, 26.23], [55.27, 25.2], [90.41, 23.81]]; // Riyadh, Manama, Dubai, Dhaka
  var START = { lon: -HUB[0] + 6, tilt: 22 };
  var AUTO = 3.2; // degrees per second
  // Illustrative wider connectivity (never labelled): London, Istanbul, Nairobi, Singapore, Shanghai.
  var GLOBAL = [[-0.12, 51.5], [28.97, 41.0], [36.82, -1.29], [103.82, 1.35], [121.47, 31.23]];

  var VS = 'attribute vec2 aLL;uniform vec4 uRot;uniform float uScale,uSize,uDpr;uniform vec3 uHub;uniform float uWave,uWaveA;varying float vA,vH,vW;' +
    'void main(){float lo=aLL.x,la=aLL.y;vec3 p=vec3(cos(la)*sin(lo),sin(la),cos(la)*cos(lo));' +
    'float h=smoothstep(0.985,0.9995,dot(p,uHub));float d=acos(clamp(dot(p,uHub),-1.0,1.0));vW=uWaveA*exp(-pow((d-uWave)/0.17,2.0));' +
    'float x=p.x*uRot.x+p.z*uRot.y;float z1=p.z*uRot.x-p.x*uRot.y;' +
    'float y=p.y*uRot.z-z1*uRot.w;float z=p.y*uRot.w+z1*uRot.z;' +
    'vA=smoothstep(-0.05,0.55,z);vH=h;gl_Position=vec4(x*uScale,y*uScale,-z*0.5,1.0);' +
    'gl_PointSize=(uSize+h*1.2+vW*1.1)*uDpr*(0.75+0.25*z);}';
  var FS_LIGHT = 'precision mediump float;varying float vA,vH,vW;void main(){vec2 c=gl_PointCoord-0.5;if(dot(c,c)>0.25)discard;' +
    'vec3 col=mix(vec3(0.0,0.44,0.81),vec3(0.0,0.21,0.55),vH);float a=min(1.0,(0.06+0.8*vA)*(1.0+vH*0.4+vW*0.9));gl_FragColor=vec4(col*a,a);}';
  // Palette v2 (homepage prototype): slate land, the origin stays signature blue.
  var FS_ATMOS = 'precision mediump float;varying float vA,vH,vW;void main(){vec2 c=gl_PointCoord-0.5;if(dot(c,c)>0.25)discard;' +
    'vec3 col=mix(mix(vec3(0.42,0.48,0.57),vec3(0.0,0.44,0.81),vH),vec3(0.0,0.44,0.81),min(1.0,vW*1.1));float a=min(1.0,(0.06+0.78*vA)*(1.0+vH*0.6+vW*1.3));gl_FragColor=vec4(col*a,a);}';
  var FS = 'precision mediump float;varying float vA,vH,vW;void main(){vec2 c=gl_PointCoord-0.5;if(dot(c,c)>0.25)discard;' +
    'vec3 col=mix(vec3(0.22,0.52,0.86),vec3(0.82,0.93,1.0),vH*0.85+vA*0.15);gl_FragColor=vec4(col*(0.25+0.75*vA),1.0)*(0.12+0.88*vA);}';

  function unit(lon, lat) { var l = lon * RAD, p = lat * RAD; return [Math.cos(p) * Math.sin(l), Math.sin(p), Math.cos(p) * Math.cos(l)]; }

  function initGlobe(root) {
    var dots = root.querySelector('.ss-website-globe__dots');
    var overlay = root.querySelector('.ss-website-globe__overlay');
    var label = root.querySelector('[data-ss-globe-label]');
    var octx = overlay.getContext('2d');
    var gl = null, prog = null, uni = {}, count = 0, ctx2d = null, points = null;
    var rotLon = START.lon, tilt = START.tilt, w = 0, h = 0, dpr = 1, size = 0;
    var vLon = 0, vTilt = 0, dragging = false, lastX = 0, lastY = 0, lastT = 0, visible = false, raf = 0, last = 0;
    var still = ss.prefersReducedMotion();
    var horizon = root.getAttribute('data-ss-globe-mode') === 'horizon';
    var simple = root.hasAttribute('data-ss-globe-simple');
    var tone = root.getAttribute('data-ss-globe-tone'), light = tone === 'light' || tone === 'atmos';
    var marketLabels = Array.prototype.slice.call(root.querySelectorAll('[data-ss-globe-node]'));
    var camLon = START.lon, camTilt = START.tilt, offLon = 0, offTilt = 0, born = 0, wave = [0, 0];
    if (horizon) { camLon = -HUB[0]; camTilt = -10; rotLon = camLon; tilt = camTilt; }

    function resize() {
      // Layout size (not the transformed box): the globe may sit inside a scaled artboard.
      var rw = root.offsetWidth || root.getBoundingClientRect().width;
      dpr = Math.min(window.devicePixelRatio || 1, rw > 1000 ? 1.5 : 2);
      size = rw;
      w = h = Math.round(rw * dpr);
      [dots, overlay].forEach(function (cv) { cv.width = w; cv.height = h; });
      if (gl) gl.viewport(0, 0, w, h);
    }

    function setupGL() {
      try { gl = dots.getContext('webgl', { alpha: true, antialias: true, premultipliedAlpha: true }); } catch (e) { gl = null; }
      if (!gl) return false;
      function sh(type, src) { var s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s); return gl.getShaderParameter(s, gl.COMPILE_STATUS) ? s : null; }
      var vs = sh(gl.VERTEX_SHADER, VS), fs = sh(gl.FRAGMENT_SHADER, tone === 'atmos' ? FS_ATMOS : light ? FS_LIGHT : FS);
      if (!vs || !fs) { gl = null; return false; }
      prog = gl.createProgram(); gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
      if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) { gl = null; return false; }
      gl.useProgram(prog);
      var data = new Float32Array(points.length);
      for (var i = 0; i < points.length; i++) data[i] = points[i] * RAD;
      count = points.length / 2;
      var buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf); gl.bufferData(gl.ARRAY_BUFFER, data, gl.STATIC_DRAW);
      var loc = gl.getAttribLocation(prog, 'aLL'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
      ['uRot', 'uScale', 'uSize', 'uDpr', 'uHub', 'uWave', 'uWaveA'].forEach(function (n) { uni[n] = gl.getUniformLocation(prog, n); });
      var hub = unit(HUB[0], HUB[1]); gl.uniform3f(uni.uHub, hub[0], hub[1], hub[2]);
      gl.enable(gl.BLEND); gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
      gl.enable(gl.DEPTH_TEST); gl.depthFunc(gl.LEQUAL);
      gl.clearColor(0, 0, 0, 0);
      return true;
    }

    // Same rotation as the shader: yaw about Y, then pitch about X. Returns [x, y, z] in -1..1.
    function rotate(v) {
      var r = rotLon * RAD, t = tilt * RAD, cr = Math.cos(r), sr = Math.sin(r), ct = Math.cos(t), st = Math.sin(t);
      var x = v[0] * cr + v[2] * sr, z1 = v[2] * cr - v[0] * sr;
      return [x, v[1] * ct - z1 * st, v[1] * st + z1 * ct];
    }
    var SCALE = 0.92; // sphere radius as a fraction of the half-size (matches the CSS body inset of 4%)
    function toScreen(p, lift) { var k = (w / 2) * SCALE * (lift || 1); return [w / 2 + p[0] * k, h / 2 - p[1] * k, p[2]]; }

    function drawDots() {
      if (gl) {
        var r = rotLon * RAD, t = tilt * RAD;
        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
        gl.uniform4f(uni.uRot, Math.cos(r), Math.sin(r), Math.cos(t), Math.sin(t));
        gl.uniform1f(uni.uScale, SCALE);
        gl.uniform1f(uni.uSize, size < 420 ? 1.7 : size > 1000 ? 3.1 : size > 700 ? 2.6 : 2.1);
        gl.uniform1f(uni.uDpr, dpr);
        gl.uniform1f(uni.uWave, wave[0]); gl.uniform1f(uni.uWaveA, wave[1]);
        gl.drawArrays(gl.POINTS, 0, count);
        return;
      }
      // 2D fallback: depth-shaded squares in four alpha buckets.
      ctx2d.clearRect(0, 0, w, h);
      var buckets = [[], [], [], []];
      for (var i = 0; i < points.length; i += 2) {
        var s = toScreen(rotate(unit(points[i], points[i + 1])));
        if (s[2] > 0) buckets[Math.min(3, Math.floor(s[2] * 4))].push(s);
      }
      var d = 1.6 * dpr;
      buckets.forEach(function (b, k) {
        ctx2d.fillStyle = (tone === 'atmos' ? 'rgba(107,122,144,' : light ? 'rgba(0,113,206,' : 'rgba(120,180,240,') + (0.2 + k * 0.22).toFixed(2) + ')';
        for (var j = 0; j < b.length; j++) ctx2d.fillRect(b[j][0] - d / 2, b[j][1] - d / 2, d, d);
      });
    }

    // Great-circle path from the hub, lifted toward the middle. Returns screen points.
    function arc(hubV, dest, lift) {
      var b = unit(dest[0], dest[1]);
      var omega = Math.acos(Math.min(1, hubV[0] * b[0] + hubV[1] * b[1] + hubV[2] * b[2]));
      var seg = 40, pts = [];
      for (var i = 0; i <= seg; i++) {
        var f = i / seg, s0 = Math.sin((1 - f) * omega) / Math.sin(omega), s1 = Math.sin(f * omega) / Math.sin(omega);
        var v = [hubV[0] * s0 + b[0] * s1, hubV[1] * s0 + b[1] * s1, hubV[2] * s0 + b[2] * s1];
        pts.push(toScreen(rotate(v), 1 + Math.sin(Math.PI * f) * (0.01 + omega * lift)));
      }
      return pts;
    }
    function stroke(pts, upto, alpha, width, dash) {
      octx.setLineDash(dash || []);
      var n = Math.floor((pts.length - 1) * upto);
      for (var i = 1; i <= n; i++) {
        var a = pts[i - 1], q = pts[i];
        if (a[2] <= 0 || q[2] <= 0) continue;
        octx.strokeStyle = 'rgba(150,205,255,' + (alpha * (0.45 + 0.55 * Math.sin(Math.PI * i / (pts.length - 1)))).toFixed(3) + ')';
        octx.lineWidth = width * dpr;
        octx.beginPath(); octx.moveTo(a[0], a[1]); octx.lineTo(q[0], q[1]); octx.stroke();
      }
      octx.setLineDash([]);
    }
    function place(el, p, front) {
      el.style.setProperty('--ss-gx', (p[0] / dpr).toFixed(1) + 'px');
      el.style.setProperty('--ss-gy', (p[1] / dpr).toFixed(1) + 'px');
      el.style.setProperty('--ss-gv', front ? Math.min(1, (p[2] - 0.08) * 4).toFixed(2) : '0');
    }

    function drawOverlay(time) {
      octx.clearRect(0, 0, w, h);
      var hubV = unit(HUB[0], HUB[1]);
      var hub = toScreen(rotate(hubV));
      var t = horizon && !still && born ? (time - born) / 1000 : 99;
      if (simple) {
        // Expansion pulse: a faint geodesic ring at the wavefront (front hemisphere only).
        if (wave[1] > 0.01 && wave[0] > 0.04) {
          var e1 = Math.abs(hubV[1]) < 0.9 ? [0, 1, 0] : [1, 0, 0];
          var dot = e1[0] * hubV[0] + e1[1] * hubV[1] + e1[2] * hubV[2];
          e1 = [e1[0] - dot * hubV[0], e1[1] - dot * hubV[1], e1[2] - dot * hubV[2]];
          var n = Math.hypot(e1[0], e1[1], e1[2]); e1 = [e1[0] / n, e1[1] / n, e1[2] / n];
          var e2 = [hubV[1] * e1[2] - hubV[2] * e1[1], hubV[2] * e1[0] - hubV[0] * e1[2], hubV[0] * e1[1] - hubV[1] * e1[0]];
          var ca = Math.cos(wave[0]), sa = Math.sin(wave[0]), prev = null;
          octx.lineWidth = 1.4 * dpr;
          for (var k = 0; k <= 120; k++) {
            var th = (k / 120) * Math.PI * 2, c0 = Math.cos(th), s0 = Math.sin(th);
            var q = toScreen(rotate([ca * hubV[0] + sa * (c0 * e1[0] + s0 * e2[0]), ca * hubV[1] + sa * (c0 * e1[1] + s0 * e2[1]), ca * hubV[2] + sa * (c0 * e1[2] + s0 * e2[2])]));
            if (prev && prev[2] > 0 && q[2] > 0) {
              octx.strokeStyle = 'rgba(0,113,206,' + (wave[1] * 0.55 * Math.min(1, q[2] * 1.6)).toFixed(3) + ')';
              octx.beginPath(); octx.moveTo(prev[0], prev[1]); octx.lineTo(q[0], q[1]); octx.stroke();
            }
            prev = q;
          }
        }
        // One quiet, unlabelled origin marker.
        if (hub[2] > 0.08) {
          octx.strokeStyle = light ? 'rgba(0,113,206,0.55)' : 'rgba(77,163,238,0.7)'; octx.lineWidth = 1.2 * dpr;
          octx.beginPath(); octx.arc(hub[0], hub[1], 10 * dpr, 0, Math.PI * 2); octx.stroke();
          octx.fillStyle = light ? '#0071CE' : '#FFFFFF'; octx.beginPath(); octx.arc(hub[0], hub[1], 3.6 * dpr, 0, Math.PI * 2); octx.fill();
        }
        return;
      }
      if (horizon) {
        // Illustrative wider connectivity: faint, dashed, unlabelled.
        GLOBAL.forEach(function (dest, k) {
          var pts = arc(hubV, dest, 0.08);
          stroke(pts, Math.min(1, Math.max(0, (t - 1.4 - k * 0.2) / 1.6)), 0.16, 1, [3 * dpr, 5 * dpr]);
          var e = pts[pts.length - 1];
          if (e[2] > 0) { octx.fillStyle = 'rgba(160,200,240,0.35)'; octx.beginPath(); octx.arc(e[0], e[1], 1.8 * dpr, 0, Math.PI * 2); octx.fill(); }
        });
      }
      LINKS.forEach(function (dest, k) {
        var pts = arc(hubV, dest, horizon ? 0.12 : 0.18);
        var drawn = horizon ? Math.min(1, Math.max(0, (t - 0.3 - k * 0.22) / 1.1)) : 1;
        stroke(pts, drawn, horizon ? 0.75 : 0.75, horizon ? 1.4 : 1.2);
        var e = pts[pts.length - 1];
        if (e[2] > 0 && drawn >= 1) { octx.fillStyle = 'rgba(200,230,255,0.95)'; octx.beginPath(); octx.arc(e[0], e[1], 2.6 * dpr, 0, Math.PI * 2); octx.fill(); }
        if (marketLabels[k]) place(marketLabels[k], e, e[2] > 0.08 && drawn >= 1);
        // Occasional directional light: one market at a time, outward from Doha.
        if (horizon && !still && t > 3) {
          var cycle = (t - 3) % 3.2, which = Math.floor((t - 3) / 3.2) % LINKS.length, f = cycle / 1.6;
          if (which === k && f < 1) {
            var q = pts[Math.round(f * (pts.length - 1))];
            if (q[2] > 0) {
              var g = octx.createRadialGradient(q[0], q[1], 0, q[0], q[1], 9 * dpr);
              g.addColorStop(0, 'rgba(255,255,255,0.95)'); g.addColorStop(1, 'rgba(77,163,238,0)');
              octx.fillStyle = g; octx.beginPath(); octx.arc(q[0], q[1], 9 * dpr, 0, Math.PI * 2); octx.fill();
            }
          }
        }
      });
      var front = hub[2] > 0.08;
      if (front) {
        // Origin: a steady halo and ring (no pulse).
        if (horizon) {
          var halo = octx.createRadialGradient(hub[0], hub[1], 0, hub[0], hub[1], 34 * dpr);
          halo.addColorStop(0, 'rgba(77,163,238,0.45)'); halo.addColorStop(1, 'rgba(77,163,238,0)');
          octx.fillStyle = halo; octx.beginPath(); octx.arc(hub[0], hub[1], 34 * dpr, 0, Math.PI * 2); octx.fill();
        }
        octx.strokeStyle = 'rgba(77,163,238,0.7)'; octx.lineWidth = 1.2 * dpr;
        octx.beginPath(); octx.arc(hub[0], hub[1], (horizon ? 12 : 9) * dpr, 0, Math.PI * 2); octx.stroke();
        octx.fillStyle = '#FFFFFF'; octx.beginPath(); octx.arc(hub[0], hub[1], (horizon ? 4.2 : 3.4) * dpr, 0, Math.PI * 2); octx.fill();
      }
      if (label) place(label, hub, front);
    }

    // Expansion pulse: wavefront angle (radians from Qatar) and strength. 4.6 s outward, ~1.8 s rest.
    function waveAt(time) {
      if (!simple) return [0, 0];
      if (still) return [0.3, 0.5];
      var t = (time - born) / 1000, P = 6.4, f = (t % P) / 4.6;
      if (t < 0.4 || f > 1) return [0, 0];
      return [0.04 + f * 2.45, Math.pow(1 - f, 1.3) * Math.min(1, f / 0.06)];
    }
    function draw(time) { time = time || performance.now(); wave = waveAt(time); drawDots(); drawOverlay(time); }

    function loop(time) {
      raf = 0;
      if (!visible || document.hidden) return;
      var dt = last ? Math.min((time - last) / 1000, 0.05) : 0;
      last = time;
      if (horizon || simple) {
        if (simple && !still) camLon = START.lon + Math.sin((time - born) / 1000 * 0.16) * 9;
        if (!dragging) { offLon += vLon; offTilt += vTilt; vLon *= 0.9; vTilt *= 0.85; offLon *= 1 - Math.min(1, dt * 2.2); offTilt *= 1 - Math.min(1, dt * 2.2); }
        rotLon = camLon + offLon; tilt = Math.max(-25, Math.min(40, camTilt + offTilt));
      } else if (!dragging) {
        vLon *= 0.95; vTilt *= 0.9;
        rotLon += vLon + (still ? 0 : AUTO * dt);
        tilt = Math.max(-15, Math.min(55, tilt + vTilt));
      }
      draw(time);
      var settling = Math.abs(vLon) + Math.abs(vTilt) > 0.01 || ((horizon || simple) && Math.abs(offLon) + Math.abs(offTilt) > 0.05);
      if (!still || dragging || settling) raf = window.requestAnimationFrame(loop);
    }
    function start() { if (!raf && points && visible) { last = 0; raf = window.requestAnimationFrame(loop); } }

    root.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true; lastX = e.clientX; lastY = e.clientY; lastT = performance.now(); vLon = vTilt = 0;
      root.setPointerCapture(e.pointerId); root.classList.add('is-dragging'); start();
    });
    root.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var k = 180 / Math.max(size, 1) * 0.9; // degrees per pixel: a full drag across ≈ 160°
      var dx = (e.clientX - lastX) * k, dy = (e.clientY - lastY) * k;
      lastX = e.clientX; lastY = e.clientY;
      if (horizon || simple) { offLon += dx; offTilt = Math.max(-20, Math.min(20, offTilt + dy)); rotLon = camLon + offLon; tilt = camTilt + offTilt; }
      else { rotLon += dx; tilt = Math.max(-15, Math.min(55, tilt + dy)); }
      vLon = dx; vTilt = dy;
      if (!raf) draw();
    });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (t) {
      root.addEventListener(t, function () { if (!dragging) return; dragging = false; root.classList.remove('is-dragging'); start(); });
    });

    function load() {
      resize();
      fetch(root.getAttribute('data-ss-globe-src')).then(function (r) { return r.json(); }).then(function (data) {
        points = data;
        if (!setupGL()) { ctx2d = dots.getContext('2d'); if (!ctx2d) return; }
        root.classList.add('is-ready', gl ? 'is-webgl' : 'is-2d');
        born = performance.now();
        draw();
        start();
      }).catch(function () { root.classList.add('is-failed'); });
    }

    // Horizon camera: a slight pan and tilt with the section's scroll progress.
    var host = root.closest('[data-ss-region]');
    if (horizon && host && !still) {
      ss.onScene(host, function (p) {
        camLon = -HUB[0] + (0.5 - p) * 12; camTilt = -10 + (0.5 - p) * 8;
        if (points && !raf) { rotLon = camLon + offLon; tilt = camTilt + offTilt; draw(); }
      }, 'view');
    }

    // Presentation hosts (Company Profile) ask the globe to redraw its paths when a scene is entered.
    root.addEventListener('ss:globe-replay', function () { born = performance.now(); if (points) { resize(); start(); } });

    var loaded = false;
    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      if (visible && !loaded) { loaded = true; load(); }
      else if (visible) start();
    }, { rootMargin: '300px 0px' }).observe(root);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) start(); });
    window.addEventListener('resize', function () { if (points) { resize(); draw(); } });
  }

  ss.ready(function () { document.querySelectorAll('[data-ss-globe]').forEach(initGlobe); });
})();

/* ==== ss-website-forms.js ==== */
/* SkyStruct forms: accessible validation, prefill (product/plan from the URL; the private project
   scope from sessionStorage), enquiry routing.
   Source preview forms (data-ss-form="preview") validate and show a local
   success state. Shopify forms validate and then submit natively. */
(function () {
  'use strict';
  var ss = window.SkyStruct;
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var PHONE = /^[+\d][\d\s\-().]{6,}$/;

  function byName(form, name) {
    return form.querySelector('[name="' + name + '"], [name="contact[' + name + ']"]');
  }

  function prefill(form) {
    var params = new URLSearchParams(window.location.search);
    var product = params.get('product');
    if (product) {
      var radio = form.querySelector('input[type="radio"][value="' + product + '"]');
      if (radio) radio.checked = true;
    }
    var plan = form.querySelector('[data-ss-plan-field]');
    if (plan && params.get('plan')) plan.value = params.get('plan');
    // Project-scope draft from the pre-footer (sessionStorage, Source preview form). Cleared only
    // once it has been placed in the field. Shopify uses ss-shopify-forms-prefill.js instead.
    var body = byName(form, 'body');
    var draft = null;
    try { draft = JSON.parse(window.sessionStorage.getItem('ss_project_scope_draft') || 'null'); } catch (e) { draft = null; }
    if (draft && draft.v && body && !body.value && form.querySelector('input[name="form"][value="contact"]')) {
      body.value = String(draft.v);
      if (body.value) { try { window.sessionStorage.removeItem('ss_project_scope_draft'); } catch (e) { /* ignore */ } }
    }
    var type = params.get('type');
    var enquiry = byName(form, 'enquiry_type');
    if (type && enquiry) {
      var map = { sales: 'Sales', support: 'Support', partnership: 'Partnership', general: 'General enquiry' };
      if (map[type]) { enquiry.value = map[type]; syncRoutes(enquiry); }
    }
  }

  function syncRoutes(select) {
    document.querySelectorAll('[data-ss-route]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-ss-route') === select.value));
    });
  }

  function fieldOf(control) { return control.closest('.ss-website-field, .ss-website-choices'); }
  function errorEl(container) { return container && container.querySelector('[data-ss-error]'); }

  function setError(container, message, controls) {
    var err = errorEl(container);
    container.classList.toggle('is-invalid', !!message);
    controls.forEach(function (c) { if (message) c.setAttribute('aria-invalid', 'true'); else c.removeAttribute('aria-invalid'); });
    if (err) { err.textContent = message || ''; err.hidden = !message; }
  }

  function validate(form, root) {
    var msgs = { required: root.getAttribute('data-ss-msg-required'), email: root.getAttribute('data-ss-msg-email'), phone: root.getAttribute('data-ss-msg-phone') };
    var firstInvalid = null;
    form.querySelectorAll('.ss-website-field__input').forEach(function (control) {
      var container = fieldOf(control);
      var value = control.value.trim();
      var message = '';
      if (control.required && !value) message = msgs.required;
      else if (value && control.type === 'email' && !EMAIL.test(value)) message = msgs.email;
      else if (value && control.type === 'tel' && !PHONE.test(value)) message = msgs.phone;
      setError(container, message, [control]);
      if (message && !firstInvalid) firstInvalid = control;
    });
    form.querySelectorAll('[data-ss-required-group]').forEach(function (group) {
      var inputs = Array.prototype.slice.call(group.querySelectorAll('input'));
      var ok = inputs.some(function (i) { return i.checked; });
      setError(group, ok ? '' : msgs.required, inputs);
      if (!ok && !firstInvalid) firstInvalid = inputs[0];
    });
    return firstInvalid;
  }

  ss.ready(function () {
    document.querySelectorAll('[data-ss-form-root]').forEach(function (root) {
      // Only the theme's own preview form. A Shopify Forms app block rendered in the same container
      // owns its own validation and submission — never touch it.
      var form = root.querySelector('form[data-ss-form]');
      if (!form) return;
      var summary = form.querySelector('[data-ss-form-summary]');
      var attempted = false;
      prefill(form);

      var enquiry = byName(form, 'enquiry_type');
      if (enquiry) {
        enquiry.addEventListener('change', function () { syncRoutes(enquiry); });
        document.querySelectorAll('[data-ss-route]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            enquiry.value = btn.getAttribute('data-ss-route');
            syncRoutes(enquiry);
            if (attempted) validate(form, root);
          });
        });
        if (!enquiry.value) { var pressed = document.querySelector('[data-ss-route][aria-pressed="true"]'); if (pressed) enquiry.value = pressed.getAttribute('data-ss-route'); }
      }

      form.addEventListener('focusout', function () { if (attempted) validate(form, root); });
      form.addEventListener('change', function () { if (attempted) validate(form, root); });

      form.addEventListener('submit', function (e) {
        attempted = true;
        var invalid = validate(form, root);
        if (invalid) {
          e.preventDefault();
          if (summary) summary.hidden = false;
          invalid.focus();
          return;
        }
        if (summary) summary.hidden = true;
        if (form.getAttribute('data-ss-form') === 'preview') {
          e.preventDefault();
          var success = root.querySelector('[data-ss-form-success]');
          form.hidden = true;
          if (success) { success.hidden = false; success.focus(); }
          ss.sfx('confirm');
        }
      });
    });
  });
})();

/* ==== ss-website-calculators.js ==== */
/* SkyStruct pricing: the Lite estimator (the only public calculator) + the Pro quote CTA.
   Rates are NOT defined here: they arrive from the rate card (src/ss-website-pricing-data.mjs) as
   the #ss-pricing-data JSON island. Tier logic mirrors the workbook Quick Quote: the total count
   selects one band and that band's rate applies to every unit. A band without a rate is Custom —
   never 0 — and disables totals. Pro is custom priced: its CTA only carries a short enquiry.
   "Send" CTAs store readable text in the namespaced sessionStorage draft (ss_project_scope_draft)
   that Contact prefills; nothing goes in the URL. */
(function () {
  'use strict';
  var DRAFT_KEY = 'ss_project_scope_draft';
  var data;
  try { data = JSON.parse((document.getElementById('ss-pricing-data') || {}).textContent || 'null'); } catch (e) { data = null; }
  if (!data && !document.querySelector('[data-ss-send="message"]')) return;

  var ar = document.documentElement.lang === 'ar';
  var AR = '٠١٢٣٤٥٦٧٨٩';
  function digits(s) { return ar ? String(s).replace(/\d/g, function (d) { return AR[d]; }) : String(s); }
  function group(n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function usd(n) { return '\u2066$' + digits(group(n)) + '\u2069'; } // LTR isolate: keeps $ before digits in Arabic
  function plain(n) { return '$' + group(n); } // contact message: Western digits read everywhere

  function band(bands, n) {
    if (!n || n < 1) return null;
    for (var i = 0; i < bands.length; i++) { var b = bands[i]; if (n >= b.min && (b.max == null || n <= b.max)) return b; }
    return null;
  }
  function bandText(b) { return '\u2066' + (b.max == null ? digits(b.min) + '+' : digits(b.min) + '–' + digits(b.max)) + '\u2069'; }
  function line(bands, n) {
    if (!n) return { n: 0, amount: 0 };
    var b = band(bands, n);
    return b && b.rate != null ? { n: n, rate: b.rate, amount: n * b.rate, band: b } : { n: n, custom: true, band: b };
  }

  function readInt(input) {
    var min = +input.min || 0, max = +input.max || 99999;
    var v = parseInt(String(input.value).replace(/[٠-٩]/g, function (d) { return AR.indexOf(d); }), 10);
    if (isNaN(v)) v = min;
    return Math.max(min, Math.min(max, v));
  }

  /* Stepper inputs (− / number / +). */
  function initQty(root, onChange) {
    root.querySelectorAll('[data-ss-qty]').forEach(function (q) {
      var input = q.querySelector('input');
      q.querySelectorAll('[data-ss-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          input.value = readInt(input) + (+btn.getAttribute('data-ss-step'));
          input.value = readInt(input);
          onChange();
        });
      });
      input.addEventListener('input', onChange);
      input.addEventListener('change', function () { input.value = readInt(input); onChange(); });
    });
    root.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(function (i) { i.addEventListener('change', onChange); });
  }

  function setText(root, sel, text) { var el = root.querySelector(sel); if (el) el.textContent = text; }
  function show(el, on) { if (el) el.hidden = !on; }

  function rateHint(root, key, l, hint, customLabel) {
    var el = root.querySelector('[data-ss-rate="' + key + '"]');
    if (!el) return;
    if (!l || !l.n || !l.band) { el.textContent = ''; return; }
    var rate = l.custom ? customLabel : usd(l.rate);
    el.textContent = hint.replace('%rate%', rate).replace('%band%', bandText(l.band));
    el.classList.toggle('is-custom', !!l.custom);
  }
  function lineOut(root, key, l, customLabel, unitRate) {
    var calc = root.querySelector('[data-ss-calc-of="' + key + '"]');
    var amt = root.querySelector('[data-ss-amount="' + key + '"]');
    var r = l.custom ? null : (l.rate != null ? l.rate : unitRate);
    if (calc) calc.textContent = l.n ? digits(l.n) + ' × ' + (r == null ? customLabel : usd(r)) : digits(0);
    if (amt) amt.textContent = l.custom ? customLabel : usd(l.amount || 0);
  }

  function send(link, text) {
    link.addEventListener('click', function () {
      try { window.sessionStorage.setItem(DRAFT_KEY, JSON.stringify({ v: text().slice(0, 1500), t: Date.now() })); } catch (e) { /* storage unavailable: Contact opens empty */ }
    });
  }
  function msg(link, key) { return link.getAttribute('data-ss-msg-' + key) || ''; }
  function labelFor(root, key) { var l = root.querySelector('[data-ss-qty="' + key + '"] label'); return l ? l.textContent.trim() : key; }

  /* ---------- Lite ---------- */
  function initLite(root) {
    var D = data.lite, hint = root.getAttribute('data-ss-hint'), customLabel = root.getAttribute('data-ss-custom');
    var state;
    function val(key) { var i = root.querySelector('[data-ss-in="' + key + '"]'); return i ? readInt(i) : 0; }
    function update() {
      var annual = (root.querySelector('input[name="billing"]:checked') || {}).value === 'annual';
      var P = line(D.projects, val('projects')), I = line(D.internal, val('internal')), E = line(D.external, val('external'));
      var A = { n: val('archived'), rate: D.archived, amount: val('archived') * D.archived };
      [['projects', P], ['internal', I], ['external', E]].forEach(function (x) { rateHint(root, x[0], x[1], hint, customLabel); });
      var archHint = root.querySelector('[data-ss-rate="archived"]'); if (archHint) archHint.textContent = '';
      lineOut(root, 'projects', P, customLabel); lineOut(root, 'internal', I, customLabel); lineOut(root, 'external', E, customLabel); lineOut(root, 'archived', A, customLabel, D.archived);
      show(root.querySelector('[data-ss-line="external"]'), E.n > 0); show(root.querySelector('[data-ss-line="archived"]'), A.n > 0);
      var custom = P.custom || I.custom || E.custom;
      var svc = D.services, training = val('training'), customization = val('customization'), integration = val('integration');
      var services = training * svc.trainingPerDay + customization * svc.customizationPerHour + integration * svc.integrationPerHour;
      var quoted = !!(root.querySelector('[data-ss-in="assisted"]:checked') || root.querySelector('[data-ss-in="premium"]:checked'));
      show(root.querySelector('[data-ss-custom-panel]'), custom);
      show(root.querySelector('[data-ss-total]'), !custom);
      var usage = 0, monthly = 0, discount = 0, annualTotal = 0;
      if (!custom) {
        usage = P.amount + I.amount + E.amount + A.amount;
        monthly = Math.max(usage, D.minimumMonthly);
        discount = annual ? monthly * 12 * D.annualDiscount : 0;
        annualTotal = monthly * 12 - discount;
        show(root.querySelector('[data-ss-minimum]'), usage < D.minimumMonthly);
        setText(root, '[data-ss-amount="usage"]', usd(usage));
        setText(root, '[data-ss-amount="monthly"]', usd(monthly));
        setText(root, '[data-ss-amount="discount"]', '−' + usd(discount));
        show(root.querySelector('[data-ss-line="discount"]'), annual);
        setText(root, '[data-ss-amount="annual"]', usd(annualTotal));
        setText(root, '[data-ss-amount="services"]', usd(services));
        show(root.querySelector('[data-ss-line="services"]'), services > 0);
        setText(root, '[data-ss-amount="year1"]', usd(annualTotal + services));
        show(root.querySelector('[data-ss-quoted]'), quoted);
      } else {
        show(root.querySelector('[data-ss-minimum]'), false);
      }
      state = { P: P, I: I, E: E, A: A, annual: annual, custom: custom, monthly: monthly, annualTotal: annualTotal, services: services, training: training, customization: customization, integration: integration, quoted: quoted };
    }
    initQty(root, update);
    update();
    var link = root.querySelector('[data-ss-send="lite"]');
    if (link) send(link, function () {
      var s = state, L = [msg(link, 'intro'), '', msg(link, 'config')];
      L.push(labelFor(root, 'projects') + ': ' + s.P.n, labelFor(root, 'internal') + ': ' + s.I.n, labelFor(root, 'external') + ': ' + s.E.n, labelFor(root, 'archived') + ': ' + s.A.n);
      var billingLabel = (root.querySelector('input[name="billing"]:checked') || {}).parentNode;
      L.push(msg(link, 'billing') + ': ' + (billingLabel ? billingLabel.querySelector('span').childNodes[0].textContent.trim() : ''));
      var extras = [];
      if (s.training) extras.push(labelFor(root, 'training') + ': ' + s.training);
      if (s.customization) extras.push(labelFor(root, 'customization') + ': ' + s.customization);
      if (s.integration) extras.push(labelFor(root, 'integration') + ': ' + s.integration);
      root.querySelectorAll('.ss-website-est__check input:checked').forEach(function (i) { extras.push(i.closest('label').querySelector('.ss-website-est__check-text span').textContent.trim()); });
      if (extras.length) L.push(msg(link, 'services') + ': ' + extras.join('; '));
      L.push('');
      if (s.custom) L.push(msg(link, 'custom'));
      else {
        L.push(msg(link, 'recurring') + ': ' + plain(s.monthly) + ' ' + msg(link, 'per-month') + (s.annual ? ' (' + plain(s.annualTotal) + ' ' + msg(link, 'per-year') + ' · ' + msg(link, 'annual') + ')' : '') + ' USD');
        L.push(msg(link, 'year1') + ': ' + plain(s.annualTotal + s.services) + ' USD');
      }
      L.push('', msg(link, 'outro'));
      return L.join('\n');
    });
  }

  function init() {
    if (data) document.querySelectorAll('[data-ss-estimator="lite"]').forEach(initLite);
    // Pro quote (custom pricing): a fixed, localized enquiry, no configuration.
    document.querySelectorAll('[data-ss-send="message"]').forEach(function (link) { send(link, function () { return link.getAttribute('data-ss-message') || ''; }); });
  }
  if (window.SkyStruct && window.SkyStruct.ready) window.SkyStruct.ready(init);
  else if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* ==== ss-website-closing.js ==== */
/* Closing chapter: pre-footer composer + background slideshow, footer accordion. */
(function () {
  'use strict';
  var ss = window.SkyStruct;

  /* Composer: grows with its text (capped), Cmd/Ctrl+Enter submits. */
  function initComposer(form) {
    var area = form.querySelector('[data-ss-autogrow]');
    if (!area) return;
    function grow() {
      area.style.height = 'auto';
      area.style.height = Math.min(area.scrollHeight, 220) + 'px';
      // A scrollbar only once the text outgrows the field (an empty track read as a stray line).
      area.style.overflowY = area.scrollHeight > 222 ? 'auto' : 'hidden';
      form.classList.toggle('has-text', area.value.trim().length > 0);
    }
    area.addEventListener('input', grow);
    // Project scope → Contact: the text travels in sessionStorage (this tab only, never in the
    // URL, never logged), then the Contact page (localized URL from the form action) prefills it.
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var text = area.value.trim();
      if (text) {
        try { window.sessionStorage.setItem('ss_project_scope_draft', JSON.stringify({ v: text.slice(0, 1500), t: Date.now() })); } catch (err) { /* storage unavailable: navigate without the draft */ }
      }
      window.location.href = form.getAttribute('action');
    });
    area.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) { e.preventDefault(); form.requestSubmit ? form.requestSubmit() : form.submit(); }
    });
    grow();
  }

  /* Slideshow: slow crossfade with a gentle push-in, only while on screen. The next slide's
     image is requested just before it is needed. Static first slide for reduced motion. */
  function initSlideshow(root) {
    var slides = root.querySelectorAll('.ss-website-prefooter__slide');
    var toggle = root.querySelector('[data-ss-slideshow-toggle]');
    if (slides.length < 2) return;
    var i = 0, timer = null, visible = false, paused = false, INTERVAL = 7000;
    function prime(k) {
      var img = slides[k % slides.length];
      var set = img.getAttribute('data-srcset');
      if (set) { img.setAttribute('srcset', set); img.removeAttribute('data-srcset'); }
    }
    function advance() {
      var next = (i + 1) % slides.length;
      var img = slides[next];
      if (!img.complete || !img.naturalWidth) { prime(next); timer = setTimeout(advance, 600); return; }
      slides[i].classList.remove('is-active');
      img.classList.add('is-active');
      i = next;
      prime(i + 1);
      schedule();
    }
    function schedule() { clearTimeout(timer); if (visible && !paused) timer = setTimeout(advance, INTERVAL); }
    function setPaused(p) {
      paused = p;
      root.classList.toggle('is-paused', p);
      if (toggle) {
        toggle.setAttribute('aria-pressed', String(p));
        toggle.setAttribute('aria-label', toggle.getAttribute(p ? 'data-ss-label-play' : 'data-ss-label-pause'));
      }
      schedule();
    }
    if (ss.prefersReducedMotion()) { root.classList.add('is-static'); if (toggle) toggle.hidden = true; return; }
    if (toggle) toggle.addEventListener('click', function () { setPaused(!paused); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        root.classList.toggle('is-offscreen', !visible);
        if (visible) prime(i + 1);
        schedule();
      }, { rootMargin: '200px 0px' }).observe(root);
    } else { visible = true; prime(1); schedule(); }
  }

  /* Footer groups: every group open on wider screens (summary inert), a compact accordion on phones. */
  function initFooter() {
    var groups = document.querySelectorAll('[data-ss-footer-group]');
    if (!groups.length) return;
    var phone = window.matchMedia('(max-width: 767px)');
    function apply() {
      groups.forEach(function (g) {
        g.open = !phone.matches;
        var s = g.querySelector('summary');
        if (phone.matches) s.removeAttribute('tabindex'); else s.setAttribute('tabindex', '-1');
      });
    }
    groups.forEach(function (g) {
      g.querySelector('summary').addEventListener('click', function (e) { if (!phone.matches) e.preventDefault(); });
    });
    apply();
    if (phone.addEventListener) phone.addEventListener('change', apply);
  }

  ss.ready(function () {
    document.querySelectorAll('[data-ss-scope-form]').forEach(initComposer);
    document.querySelectorAll('[data-ss-slideshow]').forEach(initSlideshow);
    initFooter();
  });
})();

/* ==== ss-website-cursor.js ==== */
/* SkyStruct pointer: the native system cursor is never replaced. A faint trail of SkyStruct-blue
   particles follows it on fine pointers only (none on touch, none with reduced motion). One
   fixed canvas, pointer-events: none; the frame loop runs only while particles are alive. */
(function () {
  'use strict';
  var ss = window.SkyStruct;
  var MAX = 48, LIFE = 620, DARK = '.ss-website-section--dark, .ss-website-section--navy, .ss-website-inset, .ss-website-footer, .ss-website-prefooter, .ss-website-immersive';

  ss.ready(function () {
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    if (!fine.matches || ss.prefersReducedMotion()) return;
    var canvas = document.createElement('canvas');
    canvas.className = 'ss-website-trail';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    var dpr = 1, parts = [], running = false, lx = null, ly = null, onDark = false;

    function size() {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(innerWidth * dpr); canvas.height = Math.round(innerHeight * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    size();
    window.addEventListener('resize', size, { passive: true });

    function spawn(x, y, n) {
      for (var i = 0; i < n && parts.length < MAX; i++) {
        parts.push({ x: x + (Math.random() - 0.5) * 4, y: y + (Math.random() - 0.5) * 4, vx: (Math.random() - 0.5) * 0.12, vy: -0.02 - Math.random() * 0.06, r: 0.8 + Math.random() * 1.3, t: performance.now(), dark: onDark });
      }
    }
    function frame(now) {
      ctx.clearRect(0, 0, innerWidth, innerHeight);
      for (var i = parts.length - 1; i >= 0; i--) {
        var p = parts[i], age = (now - p.t) / LIFE;
        if (age >= 1) { parts.splice(i, 1); continue; }
        p.x += p.vx * 16; p.y += p.vy * 16;
        var a = (1 - age) * (1 - age) * (p.dark ? 0.55 : 0.4);
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r * (1 - age * 0.4), 0, 6.2832);
        ctx.fillStyle = p.dark ? 'rgba(122,190,245,' + a.toFixed(3) + ')' : 'rgba(0,113,206,' + a.toFixed(3) + ')';
        ctx.fill();
      }
      if (parts.length) window.requestAnimationFrame(frame);
      else { running = false; ctx.clearRect(0, 0, innerWidth, innerHeight); }
    }

    document.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var x = e.clientX, y = e.clientY;
      if (lx === null) { lx = x; ly = y; return; }
      var dist = Math.hypot(x - lx, y - ly);
      if (dist < 6) return;
      onDark = !!(e.target.closest && e.target.closest(DARK));
      spawn(x, y, Math.min(3, Math.ceil(dist / 18)));
      lx = x; ly = y;
      if (!running) { running = true; window.requestAnimationFrame(frame); }
    }, { passive: true });
    document.documentElement.addEventListener('pointerleave', function () { lx = ly = null; });

    /* Pointer light ([data-ss-glow]) and gentle tilt ([data-ss-tilt]): one delegated listener, rAF-batched. */
    var pending = null, scheduled = false;
    document.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      pending = e;
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        var ev = pending; pending = null; scheduled = false;
        if (!ev || !ev.target.closest) return;
        var glow = ev.target.closest('[data-ss-glow]');
        if (glow) { var r = glow.getBoundingClientRect(); glow.style.setProperty('--ss-gx', (ev.clientX - r.left).toFixed(0) + 'px'); glow.style.setProperty('--ss-gy', (ev.clientY - r.top).toFixed(0) + 'px'); }
        var tilt = ev.target.closest('[data-ss-tilt]');
        if (tilt) { var t = tilt.getBoundingClientRect(); tilt.style.setProperty('--ss-tx', ((ev.clientX - t.left) / t.width * 2 - 1).toFixed(3)); tilt.style.setProperty('--ss-ty', ((ev.clientY - t.top) / t.height * 2 - 1).toFixed(3)); tilt.setAttribute('data-ss-tilting', ''); }
      });
    }, { passive: true });
    document.addEventListener('pointerout', function (e) {
      var tilt = e.target.closest && e.target.closest('[data-ss-tilt]');
      if (tilt && !tilt.contains(e.relatedTarget)) { tilt.style.setProperty('--ss-tx', 0); tilt.style.setProperty('--ss-ty', 0); }
    });
  });
})();

/* ==== ss-website-engage.js ==== */
/* SkyStruct engagement: (1) a once-per-session, non-modal "book a demo" prompt for engaged
   visitors; (2) a quiet tab title while the tab is in the background.

   Prompt: counts ACTIVE seconds only — the tab is visible and the visitor interacted within the
   last 20 s — summed across pages in sessionStorage. At 60 s it appears once (bottom-inline-start
   on desktop, a compact card above the dock on phones), unless something else needs the visitor:
   the Demo page, the Company Profile, a menu / mobile menu / dock / any modal open, the entry
   screen still up, or a form the visitor has started. Shown or dismissed = done for the session.
   Never moves or traps focus (it is a complementary prompt, not a modal).

   Tab title: on visibilitychange → hidden, the current runtime title is stored and replaced by
   the localised [data-ss-away] text; on return the stored title is restored exactly. Server-side
   titles, SEO and Open Graph metadata are untouched. Off in the Shopify Theme Editor and in the
   Company Profile (a presentation keeps its own title). */
(function () {
  'use strict';
  var ss = window.SkyStruct;
  var html = document.documentElement;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var page = function () { return document.body.getAttribute('data-ss-page') || ''; };
  var store = {
    get: function (k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) { /* optional */ } },
  };

  ss.ready(function () {
    /* ---------- Tab title ---------- */
    // Shopify's t filter returns HTML-escaped text (We&#39;re); decode entities so document.title
    // receives a plain string (also safe if the value is escaped twice).
    var decode = function (v) { var t = document.createElement('textarea'); for (var i = 0; i < 2 && /&(#\d+|#x[0-9a-f]+|[a-z]+);/i.test(v); i++) { t.innerHTML = v; v = t.value; } return v; };
    var away = decode(document.body.getAttribute('data-ss-away') || '');
    if (away && !designMode && !/profile/.test(page())) {
      var original = null;
      var restore = function () { if (original !== null) { document.title = original; original = null; } };
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') { if (original === null) { original = document.title; document.title = away; } }
        else restore();
      });
      window.addEventListener('pageshow', restore);
    }

    /* ---------- Engagement prompt ---------- */
    var card = document.querySelector('[data-ss-engage]');
    var KEY = 'ss-website-engage';
    if (!card || designMode || /demo|profile/.test(page()) || store.get(KEY) === 'done') return;
    var TARGET = 60, IDLE = 20000;
    var active = parseInt(store.get(KEY + '-t') || '0', 10) || 0;
    var lastInput = Date.now(), formStarted = false;
    ['scroll', 'wheel', 'pointermove', 'pointerdown', 'keydown', 'touchstart'].forEach(function (ev) {
      window.addEventListener(ev, function () { lastInput = Date.now(); }, { passive: true, capture: true });
    });
    document.addEventListener('focusin', function (e) {
      if (e.target.closest && e.target.closest('form, [data-ss-shopify-form], [data-ss-form]') && !card.contains(e.target)) formStarted = true;
    });
    function busy() {
      if (formStarted || html.classList.contains('is-nav-locked')) return true;
      if (html.classList.contains('is-entry') && !html.classList.contains('is-entry-done')) return true;
      if (document.querySelector('.ss-website-header.is-menu-open, .ss-website-dock.is-open, [aria-modal="true"]:not([hidden])')) return true;
      var a = document.activeElement;
      return !!(a && a.matches && a.matches('input, textarea, select'));
    }
    var timer = setInterval(function () {
      if (document.visibilityState !== 'visible' || Date.now() - lastInput > IDLE) return;
      active += 1;
      if (active % 5 === 0) store.set(KEY + '-t', String(active));
      if (active >= TARGET && !busy()) show();
    }, 1000);
    function show() {
      clearInterval(timer);
      store.set(KEY, 'done');
      card.hidden = false;
      window.requestAnimationFrame(function () { card.classList.add('is-in'); });
    }
    function close() {
      card.classList.remove('is-in');
      var hadFocus = card.contains(document.activeElement);
      window.setTimeout(function () { card.hidden = true; }, ss.prefersReducedMotion() ? 0 : 320);
      if (hadFocus) { var main = document.getElementById('ss-main'); if (main) main.focus({ preventScroll: true }); }
    }
    card.querySelector('[data-ss-engage-close]').addEventListener('click', close);
    card.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  });
})();

/* ==== ss-website-profile.js ==== */
/* SkyStruct Company Profile: the presentation controller (one state model, one clock).

   State: current scene, autoplay (playing / paused), elapsed time in the scene, sound, fullscreen,
   contents overlay and portrait recomposition. One requestAnimationFrame clock drives the autoplay progress
   (rail segment + ring on the play button); nothing else keeps a timer.

   - Artboard: every scene is composed at 1600×900; --pf-s scales it to the viewport (letterboxed
     by the scene's own full-bleed background). --pf-b enlarges small copy on small screens.
   - Scenes: [data-ss-scene-i], autoplay seconds in data-ss-dur (default 10), arrival transition in
     data-ss-tx (line | cloud | glass | zoom | dark). Entering a scene (auto or manual) always replays
     its choreography. Autoplay stops on the last scene; pause stays paused until resumed.
   - Portrait screens: the same scenes recomposed on a 900×1600 artboard (layoutTall); turning the
     device re-fits the current chapter without interrupting autoplay or sound.
   - Input: buttons; ← / → (mirrored in RTL), Space, M, F, Esc, Home, End; horizontal swipe.
   - Sound starts on "Enter experience" (a user gesture), via the site audio engine.
   - Deep links: #<chapter-slug> opens that chapter after Enter; the hash follows the scene. */
(function () {
  'use strict';
  var ss = window.SkyStruct;

  ss.ready(function () {
    var root = document.querySelector('[data-ss-profile]');
    if (!root) return;
    var html = document.documentElement;
    var scenes = Array.prototype.slice.call(root.querySelectorAll('[data-ss-scene-i]'));
    var N = scenes.length;
    var $ = function (sel) { return root.querySelector(sel); };
    var btn = function (name) { return root.querySelector('[data-ss-pf="' + name + '"]'); };
    var entry = $('[data-ss-pf-entry]'), contents = $('[data-ss-pf-contents]'), live = $('[data-ss-pf-live]');
    var playBtn = btn('play'), soundBtn = btn('sound'), fsBtn = btn('fullscreen'), contentsBtn = btn('contents');
    var ring = root.querySelector('.ss-website-pf-ctrl__ring-fill');
    var segs = Array.prototype.slice.call(root.querySelectorAll('[data-ss-seg]'));
    var chapterButtons = Array.prototype.slice.call(root.querySelectorAll('[data-ss-goto]'));
    var titles = chapterButtons.map(function (b) { return b.querySelector('b').textContent; });
    var lang = html.lang || 'en';
    var fmt = (function () { try { var f = new Intl.NumberFormat(/^ar/.test(lang) ? 'ar-u-nu-arab' : lang, { minimumIntegerDigits: 2, useGrouping: false }); return function (n) { return f.format(n); }; } catch (e) { return function (n) { return (n < 10 ? '0' : '') + n; }; } })();

    var S = { i: -1, playing: false, elapsed: 0, sound: false, entered: false, contents: false, resumeAfterContents: false, tall: false };
    var NOFRAME = { 0: true, 17: true }; // the cover and the closing scene carry their own logo
    var TX_MS = { line: 650, cloud: 800, glass: 700, zoom: 650, dark: 850 };

    /* ---------- Artboard scale ---------- */
    /* Portrait screens (phones held upright, narrow windows): the same scenes on a 900×1600
       artboard. The copy block moves to the top (CSS); the scene's visual group (.ss-website-pf-vis,
       built once below, identity in landscape) is scaled and centred into the space beneath it —
       a controlled crop of the desktop composition, never a re-design. */
    var COPY_RE = /(__copy|__head|tier__copy)(\s|$)|(^|\s)ss-website-pf-h2(\s|$)/;
    var BG_RE = /__(arch|clouds|bg|glow|light|waves|beam)(\s|$)|tier__glow(\s|$)/;
    scenes.forEach(function (scene) {
      var art = scene.querySelector('.ss-website-pf-art');
      if (!art || art.querySelector(':scope > .ss-website-pf-vis')) return;
      var vis = document.createElement('div');
      vis.className = 'ss-website-pf-vis';
      Array.prototype.slice.call(art.children).forEach(function (k) {
        var cls = k.getAttribute('class') || '';
        if (COPY_RE.test(cls) || BG_RE.test(cls)) return;
        if (!vis.parentNode) art.insertBefore(vis, k);
        vis.appendChild(k);
      });
    });
    function layoutTall(scene) {
      var art = scene && scene.querySelector('.ss-website-pf-art');
      var vis = art && art.querySelector(':scope > .ss-website-pf-vis');
      if (!vis) return;
      // Scenes 02–18 have their own portrait composition in CSS (by scene type); only the cover uses
      // the generic visual fit.
      if (!S.tall || scenes.indexOf(scene) > 0) { vis.style.transform = ''; art.style.removeProperty('--pf-tall-shift'); return; }
      art.style.removeProperty('--pf-tall-shift');
      var copyBottom = 120;
      Array.prototype.forEach.call(art.children, function (k) {
        if (COPY_RE.test(k.getAttribute('class') || '')) copyBottom = Math.max(copyBottom, k.offsetTop + k.offsetHeight);
      });
      var x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
      // Union of the visual boxes; a full-artboard layout container counts by its children instead.
      (function add(list, ox, oy, deep) {
        Array.prototype.forEach.call(list, function (k) {
          if (k instanceof SVGElement || !k.offsetWidth) return;
          if (k.offsetWidth >= 1500 && deep < 2 && k.children.length) { add(k.children, ox + k.offsetLeft, oy + k.offsetTop, deep + 1); return; }
          x0 = Math.min(x0, ox + k.offsetLeft); y0 = Math.min(y0, oy + k.offsetTop);
          x1 = Math.max(x1, ox + k.offsetLeft + k.offsetWidth); y1 = Math.max(y1, oy + k.offsetTop + k.offsetHeight);
        });
      })(vis.children, 0, 0, 0);
      if (!isFinite(x0)) { vis.style.transform = ''; return; }
      // Visual directly under the copy; the copy + visual block is then centred in the frame
      // (between the logo and the controls), so no empty band opens between words and picture.
      var top = copyBottom + 64, bottom = 1600 - 190, zoneH = Math.max(200, bottom - top);
      var k = Math.min(1.15, 860 / (x1 - x0), zoneH / (y1 - y0));
      var shift = Math.max(0, Math.min(320, (bottom - (top + (y1 - y0) * k)) / 2));
      art.style.setProperty('--pf-tall-shift', shift.toFixed(0) + 'px');
      var tx = 450 - (x0 + (x1 - x0) / 2) * k, ty = top + shift - y0 * k;
      vis.style.transform = 'translate(' + tx.toFixed(1) + 'px, ' + ty.toFixed(1) + 'px) scale(' + k.toFixed(4) + ')';
    }
    function fit() {
      var w = window.innerWidth, h = window.innerHeight;
      var tall = w < h * 0.9;
      var s, reserve = 0;
      if (tall) s = Math.min(w / 900, h / 1600);
      else {
        // Short screens (phone landscape): keep a strip for the compact controls below the artboard.
        reserve = h < 520 ? 40 : 0;
        s = Math.min(w / 1600, (h - reserve) / 900);
      }
      var changed = tall !== S.tall;
      S.tall = tall;
      root.classList.toggle('is-tall', tall);
      root.style.setProperty('--pf-s', s.toFixed(4));
      root.style.setProperty('--pf-shift', (-reserve / 2) + 'px');
      root.style.setProperty('--pf-b', tall ? (s < 0.5 ? '1.42' : '1.25') : s < 0.5 ? '1.18' : s < 0.62 ? '1.1' : '1');
      if (S.i > -1) layoutTall(scenes[S.i]);
      if (changed && !tall) scenes.forEach(function (sc) { layoutTall(sc); });
    }
    fit();
    window.addEventListener('resize', fit);

    /* ---------- Assets: hydrate the current scene and its neighbours only ---------- */
    function hydrate(i) {
      [i, i + 1, i - 1].forEach(function (k) {
        if (k < 0 || k >= N) return;
        scenes[k].querySelectorAll('img[data-ss-src]').forEach(function (img) { img.src = img.getAttribute('data-ss-src'); img.removeAttribute('data-ss-src'); });
      });
    }
    function dur(scene) { return parseFloat(scene.getAttribute('data-ss-dur')) || 10; }

    /* ---------- Data that counts up (Momentum) ---------- */
    function countUp(scene) {
      scene.querySelectorAll('[data-ss-count]').forEach(function (el) {
        var text = el.getAttribute('data-ss-count-text') || el.textContent;
        el.setAttribute('data-ss-count-text', text);
        var m = text.match(/(\d+(?:\.\d+)?)/);
        if (!m || ss.prefersReducedMotion()) { el.textContent = text; return; }
        var target = parseFloat(m[1]), decimals = (m[1].split('.')[1] || '').length;
        var delay = (parseFloat(getComputedStyle(el).getPropertyValue('--d')) || 0) * 420, t0 = 0, run = S.i;
        var draw = function (v) { el.textContent = text.replace(m[1], v.toFixed(decimals)); };
        draw(0);
        var step = function (t) {
          if (S.i !== run) { el.textContent = text; return; }
          if (!t0) t0 = t;
          var p = Math.min(1, Math.max(0, (t - t0 - delay) / 1000));
          draw(target * (1 - Math.pow(1 - p, 3)));
          if (p < 1) window.requestAnimationFrame(step); else el.textContent = text;
        };
        window.requestAnimationFrame(step);
      });
    }

    /* ---------- Scene changes ---------- */
    var txTimer = 0;
    function go(i, opts) {
      opts = opts || {};
      i = Math.max(0, Math.min(N - 1, i));
      if (i === S.i && !opts.force) return;
      var prev = S.i, dir = opts.dir || (i >= prev ? 'fwd' : 'back');
      var scene = scenes[i];
      var tx = scene.getAttribute('data-ss-tx') || 'line';
      root.setAttribute('data-ss-dir', dir);
      root.setAttribute('data-ss-txnow', tx);
      var animate = S.entered && prev > -1 && prev !== i && !ss.prefersReducedMotion();
      if (prev > -1 && prev !== i) {
        var old = scenes[prev];
        old.classList.remove('is-active');
        old.classList.add('is-leaving');
        window.setTimeout(function () { if (!old.classList.contains('is-active')) { old.classList.remove('is-leaving'); old.hidden = true; } }, animate ? TX_MS[tx] + 50 : 0);
      }
      hydrate(i);
      scene.classList.remove('is-leaving', 'is-active');
      // Re-entering a scene replays its choreography from the start (display:none resets animations).
      scene.hidden = true; void scene.offsetWidth;
      scene.hidden = false;
      layoutTall(scene);
      root.classList.remove('is-tx');
      void scene.offsetWidth;
      if (animate) {
        root.classList.add('is-tx');
        window.clearTimeout(txTimer);
        txTimer = window.setTimeout(function () { root.classList.remove('is-tx'); }, TX_MS[tx] + 60);
      }
      scene.classList.add('is-active');
      S.i = i; S.elapsed = 0;
      root.setAttribute('data-ss-tone-now', scene.getAttribute('data-ss-tone'));
      root.classList.toggle('is-noframe', !!NOFRAME[i]);
      // Chrome: number, title, rail, contents, folio, live region, hash.
      $('[data-ss-pf-num]').textContent = fmt(i + 1);
      $('[data-ss-pf-title]').textContent = titles[i];
      $('[data-ss-pf-count]').textContent = fmt(i + 1);
      $('[data-ss-pf-folio]').textContent = fmt(i + 1);
      segs.forEach(function (s, k) { s.classList.toggle('is-done', k < i); s.firstChild.style.transform = k < i ? 'scaleX(1)' : 'scaleX(0)'; });
      chapterButtons.forEach(function (b, k) { if (k === i) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current'); });
      live.textContent = fmt(i + 1) + ' / ' + fmt(N) + ' — ' + titles[i];
      btn('prev').disabled = i === 0;
      btn('next').disabled = i === N - 1;
      if (S.entered && window.history && window.history.replaceState) { try { window.history.replaceState(null, '', '#' + scene.id); } catch (e) { /* file:// */ } }
      if (animate) ss.sfx(tx === 'dark' ? 'deep' : tx === 'glass' ? 'glass' : tx === 'zoom' ? 'zoom' : 'scene');
      countUp(scene);
      // The globe (Region) redraws its coverage paths outward from Qatar each time it is entered.
      var globe = scene.querySelector('[data-ss-globe]');
      if (globe) globe.dispatchEvent(new CustomEvent('ss:globe-replay'));
      paint();
    }
    function next() { if (S.i < N - 1) go(S.i + 1, { dir: 'fwd' }); }
    function prev() { if (S.i > 0) go(S.i - 1, { dir: 'back' }); }

    /* ---------- Autoplay clock ---------- */
    var last = 0, raf = 0;
    function paint() {
      var p = Math.min(1, S.elapsed / dur(scenes[S.i]));
      if (ring) ring.style.strokeDashoffset = String(1 - p);
      var seg = segs[S.i]; if (seg) seg.firstChild.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    }
    function frame(t) {
      raf = 0;
      if (!S.playing) return;
      var dt = last ? Math.min(0.1, (t - last) / 1000) : 0;
      last = t;
      S.elapsed += dt;
      if (S.elapsed >= dur(scenes[S.i])) {
        if (S.i < N - 1) go(S.i + 1, { dir: 'fwd' });
        else { S.elapsed = dur(scenes[S.i]); setPlaying(false); }
      }
      paint();
      raf = window.requestAnimationFrame(frame);
    }
    function setPlaying(on) {
      S.playing = on;
      root.classList.toggle('is-playing', on);
      playBtn.setAttribute('aria-label', playBtn.getAttribute(on ? 'data-ss-label-pause' : 'data-ss-label-play'));
      if (on) {
        if (S.i === N - 1 && S.elapsed >= dur(scenes[S.i])) go(0, { force: true, dir: 'fwd' });
        last = 0; if (!raf) raf = window.requestAnimationFrame(frame);
        idle();
      } else { if (raf) window.cancelAnimationFrame(raf); raf = 0; wake(); }
    }

    /* ---------- Controls dim while playing and idle ---------- */
    var idleTimer = 0;
    function wake() { root.classList.remove('is-idle'); idle(); }
    function idle() {
      window.clearTimeout(idleTimer);
      if (!S.playing || S.contents || !S.entered) return;
      idleTimer = window.setTimeout(function () {
        var a = document.activeElement, kb = false; try { kb = a && a.matches(':focus-visible'); } catch (e) { kb = false; }
        if (S.playing && !S.contents && !(kb && root.querySelector('.ss-website-pf__controls').contains(a))) root.classList.add('is-idle');
      }, 2600);
    }
    ['pointermove', 'pointerdown', 'touchstart'].forEach(function (ev) { root.addEventListener(ev, wake, { passive: true }); });
    document.addEventListener('keydown', wake, true);

    /* ---------- Sound ---------- */
    function setSound(on, uiOnly) {
      var ok = uiOnly ? false : (ss.presentationAudio ? ss.presentationAudio(on) : false);
      S.sound = !!(on && ok);
      root.classList.toggle('is-muted', !S.sound);
      soundBtn.setAttribute('aria-pressed', String(S.sound));
      soundBtn.setAttribute('aria-label', soundBtn.getAttribute(S.sound ? 'data-ss-label-on' : 'data-ss-label-off'));
    }

    /* ---------- Fullscreen (an enhancement: the player is already 100dvh) ---------- */
    var fsEnabled = !!(document.fullscreenEnabled || document.webkitFullscreenEnabled);
    if (!fsEnabled) fsBtn.hidden = true;
    function isFs() { return !!(document.fullscreenElement || document.webkitFullscreenElement); }
    function toggleFs() {
      if (!fsEnabled) return;
      if (isFs()) (document.exitFullscreen || document.webkitExitFullscreen).call(document);
      else { var el = document.documentElement; var r = (el.requestFullscreen || el.webkitRequestFullscreen).call(el); if (r && r.catch) r.catch(function () {}); }
    }
    function onFs() {
      var on = isFs();
      root.classList.toggle('is-fullscreen', on);
      fsBtn.setAttribute('aria-label', fsBtn.getAttribute(on ? 'data-ss-label-exit' : 'data-ss-label-enter'));
    }
    document.addEventListener('fullscreenchange', onFs);
    document.addEventListener('webkitfullscreenchange', onFs);

    /* ---------- Contents ---------- */
    var opener = null;
    function openContents() {
      if (S.contents) return;
      S.contents = true; S.resumeAfterContents = S.playing;
      if (S.playing) setPlaying(false);
      opener = document.activeElement;
      contents.hidden = false;
      void contents.offsetWidth;
      contents.classList.add('is-open');
      contentsBtn.setAttribute('aria-expanded', 'true');
      root.classList.remove('is-idle');
      var cur = chapterButtons[Math.max(0, S.i)];
      window.setTimeout(function () { (cur || contents.querySelector('button')).focus({ preventScroll: true }); }, 30);
      ss.sfx('open');
    }
    function closeContents(resume, focusBack) {
      if (!S.contents) return;
      S.contents = false;
      contents.classList.remove('is-open');
      contentsBtn.setAttribute('aria-expanded', 'false');
      window.setTimeout(function () { if (!S.contents) contents.hidden = true; }, ss.prefersReducedMotion() ? 0 : 300);
      if (focusBack !== false && opener && opener.focus) opener.focus();
      if (resume !== false && S.resumeAfterContents) setPlaying(true);
    }
    contents.addEventListener('click', function (e) {
      if (e.target === contents) closeContents();
      var b = e.target.closest('[data-ss-goto]');
      if (b) { var k = parseInt(b.getAttribute('data-ss-goto'), 10); closeContents(false, false); go(k, { force: true }); setPlaying(S.resumeAfterContents); playBtn.focus(); }
    });
    contents.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = contents.querySelectorAll('button'); var first = f[0], lastEl = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
    });

    /* ---------- Entry ---------- */
    function startIndex() {
      var h = (window.location.hash || '').slice(1);
      for (var k = 0; k < N; k++) if (scenes[k].id === h) return k;
      return 0;
    }
    function enter(withContents) {
      if (S.entered) return;
      S.entered = true;
      root.classList.remove('is-entry');
      root.classList.add('is-entered');
      setSound(true);
      go(startIndex(), { force: true });
      window.setTimeout(function () { entry.hidden = true; }, ss.prefersReducedMotion() ? 0 : 900);
      if (withContents) { openContents(); S.resumeAfterContents = true; }
      else { setPlaying(true); playBtn.focus({ preventScroll: true }); }
    }

    /* ---------- Wiring ---------- */
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ss-pf]');
      if (!b) return;
      switch (b.getAttribute('data-ss-pf')) {
        case 'enter': enter(false); break;
        case 'enter-contents': enter(true); break;
        case 'prev': prev(); break;
        case 'next': next(); break;
        case 'play': setPlaying(!S.playing); break;
        case 'contents': if (S.contents) closeContents(); else openContents(); break;
        case 'close': closeContents(); break;
        case 'sound': setSound(!S.sound); break;
        case 'fullscreen': toggleFs(); break;
        case 'replay': go(0, { force: true, dir: 'back' }); setPlaying(true); break;
      }
    });

    var rtl = ss.isRtl();
    document.addEventListener('keydown', function (e) {
      if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey) return;
      var t = e.target, tag = t && t.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (t && t.isContentEditable)) return;
      if (e.key === 'Escape') { if (S.contents) { e.preventDefault(); closeContents(); } return; }
      if (!S.entered || S.contents) return;
      var onControl = t && t.closest && t.closest('button, a, [role="button"]');
      switch (e.key) {
        case 'ArrowRight': e.preventDefault(); if (rtl) prev(); else next(); break;
        case 'ArrowLeft': e.preventDefault(); if (rtl) next(); else prev(); break;
        case ' ': case 'Spacebar': if (onControl) return; e.preventDefault(); setPlaying(!S.playing); break;
        case 'm': case 'M': setSound(!S.sound); break;
        case 'f': case 'F': toggleFs(); break;
        case 'Home': if (onControl) return; e.preventDefault(); go(0); break;
        case 'End': if (onControl) return; e.preventDefault(); go(N - 1); break;
      }
    });

    // Touch: horizontal swipe (vertical movement is ignored).
    var stage = $('[data-ss-pf-stage]'), touch = null;
    stage.addEventListener('touchstart', function (e) { if (e.touches.length !== 1) { touch = null; return; } var t0 = e.touches[0]; touch = { x: t0.clientX, y: t0.clientY, t: Date.now() }; }, { passive: true });
    stage.addEventListener('touchcancel', function () { touch = null; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (!touch || !S.entered || S.contents) { touch = null; return; }
      var end = e.changedTouches && e.changedTouches[0];
      var dx = (end ? end.clientX : touch.x) - touch.x, dy = (end ? end.clientY : touch.y) - touch.y, dt = Date.now() - touch.t;
      touch = null;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.6 && dt < 900) {
        if ((dx < 0) !== rtl) next(); else prev();
      }
    }, { passive: true });

    document.addEventListener('visibilitychange', function () { last = 0; });

    // Initial state: scene 01 composed under the entry screen (no autoplay, no sound yet).
    go(0, { force: true });
    setSound(false, true);
    var enterBtn = btn('enter');
    if (enterBtn) window.setTimeout(function () { try { enterBtn.focus({ preventScroll: true }); } catch (err) { /* old browsers */ } }, 60);
  });
})();

/* ==== ss-website-newsroom.js ==== */
/* SkyStruct Newsroom: search + topic + date filtering over the rendered article cards (Source
   demo cards or Shopify blog.articles), URL state (?q=&tag=&date=), localized dates, and on the
   article page: reading progress (article body only), share links (current article URL) and
   copy link. */
(function () {
  'use strict';
  var lang = document.documentElement.lang || 'en';
  var ar = lang.indexOf('ar') === 0;
  var AR = '٠١٢٣٤٥٦٧٨٩';
  function digits(s) { return ar ? String(s).replace(/\d/g, function (d) { return AR[d]; }) : String(s); }

  /* Localized dates (Shopify prints a neutral English date; the browser localizes it). */
  document.querySelectorAll('time[data-ss-date]').forEach(function (t) {
    var iso = t.getAttribute('datetime'); if (!iso) return;
    var d = new Date(iso + 'T12:00:00Z'); if (isNaN(d)) return;
    try { t.textContent = d.toLocaleDateString(ar ? 'ar' : 'en-GB', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' }); } catch (e) { /* keep server text */ }
  });
  if (ar) document.querySelectorAll('.ss-website-news-author small').forEach(function (s) { s.innerHTML = s.innerHTML.replace(/(^|>)([^<]*)/g, function (m, a, b) { return a + digits(b); }); });

  /* ---------- Listing ---------- */
  var root = document.querySelector('[data-ss-newsroom]');
  if (root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ss-news-card]'));
    var q = root.querySelector('[data-ss-news-q]'), tagSel = root.querySelector('[data-ss-news-tag]'), dateSel = root.querySelector('[data-ss-news-date]');
    var count = root.querySelector('[data-ss-news-count]'), emptyEl = root.querySelector('[data-ss-news-empty]');
    var clearBtns = root.querySelectorAll('[data-ss-news-clear]');
    var norm = function (s) { return String(s || '').toLocaleLowerCase(lang).normalize('NFKD').replace(/[ً-ْ̀-ͯ]/g, ''); };
    // Options derived from the published articles (no hardcoded topics or years).
    var tags = {}, years = {};
    cards.forEach(function (c) {
      (c.getAttribute('data-tags') || '').split('|').forEach(function (t) { t = t.trim(); if (t) tags[t] = (tags[t] || 0) + 1; });
      var y = (c.getAttribute('data-date') || '').slice(0, 4); if (y) years[y] = 1;
    });
    Object.keys(tags).sort(function (a, b) { return a.localeCompare(b, lang); }).forEach(function (t) { var o = document.createElement('option'); o.value = t; o.textContent = t; tagSel.appendChild(o); });
    Object.keys(years).sort().reverse().forEach(function (y) { var o = document.createElement('option'); o.value = y; o.textContent = digits(y); dateSel.appendChild(o); });

    var params = new URLSearchParams(location.search);
    q.value = params.get('q') || '';
    if (params.get('tag') && tags[params.get('tag')]) tagSel.value = params.get('tag');
    if (params.get('date')) dateSel.value = params.get('date');

    function apply(push) {
      var term = norm(q.value.trim()), tag = tagSel.value, date = dateSel.value, shown = 0;
      var cutoff = Date.now() - 90 * 864e5;
      cards.forEach(function (c) {
        var ok = true;
        if (term) ok = norm(c.getAttribute('data-text')).indexOf(term) > -1;
        if (ok && tag) ok = (c.getAttribute('data-tags') || '').split('|').indexOf(tag) > -1;
        if (ok && date) { var d = c.getAttribute('data-date') || ''; ok = date === 'latest' ? new Date(d).getTime() >= cutoff : d.slice(0, 4) === date; }
        c.hidden = !ok; if (ok) shown++;
      });
      var active = !!(term || tag || date);
      clearBtns.forEach(function (b, i) { if (i === 0) b.hidden = !active; });
      emptyEl.hidden = shown > 0 || !cards.length;
      count.textContent = shown === 1 ? count.getAttribute('data-one') : count.getAttribute('data-many').replace('%n', digits(shown));
      if (push) {
        var p = new URLSearchParams(location.search);
        [['q', q.value.trim()], ['tag', tag], ['date', date]].forEach(function (kv) { if (kv[1]) p.set(kv[0], kv[1]); else p.delete(kv[0]); });
        var s = p.toString();
        history.replaceState(null, '', location.pathname + (s ? '?' + s : '') + location.hash);
      }
    }
    var timer;
    q.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(function () { apply(true); }, 160); });
    tagSel.addEventListener('change', function () { apply(true); });
    dateSel.addEventListener('change', function () { apply(true); });
    clearBtns.forEach(function (b) { b.addEventListener('click', function () { q.value = ''; tagSel.value = ''; dateSel.value = ''; apply(true); q.focus(); }); });
    // Clicking a card tag filters by it.
    apply(false);
  }

  /* ---------- Article ---------- */
  var body = document.querySelector('[data-ss-read-body]');
  var bar = document.querySelector('[data-ss-read-progress]');
  if (body && bar) {
    var raf = 0;
    var update = function () {
      raf = 0;
      var r = body.getBoundingClientRect(), vh = window.innerHeight;
      var total = r.height - vh * 0.6;
      var p = total > 0 ? Math.min(1, Math.max(0, (vh * 0.4 - r.top) / total)) : (r.top < vh ? 1 : 0);
      bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    };
    window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  var share = document.querySelector('[data-ss-share]');
  if (share) {
    var canon = document.querySelector('link[rel="canonical"]');
    var url = canon ? canon.href : location.href.split('#')[0];
    var title = (document.querySelector('.ss-website-news-article__title') || {}).textContent || document.title;
    var u = encodeURIComponent(url), t = encodeURIComponent(title.trim());
    var targets = {
      linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=' + u,
      x: 'https://twitter.com/intent/tweet?url=' + u + '&text=' + t,
      facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + u,
      whatsapp: 'https://wa.me/?text=' + t + '%20' + u
    };
    share.querySelectorAll('[data-ss-share-to]').forEach(function (a) { a.href = targets[a.getAttribute('data-ss-share-to')]; });
    var copy = share.querySelector('[data-ss-share-copy]'), toast = share.querySelector('[data-ss-share-toast]');
    copy.addEventListener('click', function () {
      var done = function () { toast.textContent = copy.getAttribute('data-copied'); share.classList.add('is-copied'); setTimeout(function () { share.classList.remove('is-copied'); toast.textContent = ''; }, 1800); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, done);
      else { var i = document.createElement('input'); i.value = url; document.body.appendChild(i); i.select(); try { document.execCommand('copy'); } catch (e) { /* ignore */ } i.remove(); done(); }
    });
  }
})();
